export const locale = {
  GENERAL: {
    NO_DATA: 'No Available Data',
    CANCEL: 'Cancel',
    CONFIRM: 'Confirm',
    ADD: 'Add',
    EDIT: 'Edit',
    COPY: 'Copy',
    COPIED: 'Copied',
    DELETE: 'Delete',
    SAVE: 'Save',
    SHOW_CONTENT: 'SHOW CONTENT',
    HIDE_CONTENT: 'HIDE CONTENT',
    AUTH: 'Not authorized to view the contents of this object',
    DAY: 'Days',
    ALL: 'All',
    RELEASE: 'Release',
    APPLY: 'Apply',
    RESTART_EDITING: 'Restart Edit',
    CHANGE_OWNER: 'Change Owner',
    CHANGE_OWNER_2: 'Change Agent',
    CHANGE_OWNER_3: 'Change Author',
    ADD_DEAL: 'Opportunity',
    ADD_Case: 'Case',
    CLOSE: 'Close',
    PIN: 'Pin',
    FIELDHISTORY: 'Field History',
    NO_FIELDHISTORY: 'No Field History',
    NO_EMAIL: 'No Email',
    NO_SMS: 'No SMS',
    ACTIVE: 'Active',
    LOGOUT: 'Log out',
    SUCCESS: 'SUCCESS',
    DASHBOARD: 'Dashboard',
    DATASHEET: 'View',
    NEXT: 'Next',
    PRE: 'Previous',
    NONE: 'None',
    MAIL: 'Email',
    LAST_NAME: 'Last name',
    FIRST_NAME: 'First name',
    SHORTCUTS: 'Shortcuts',
    STATUS: 'Status Setting',
    REFRESH: 'Refresh',
    SETTING_BTN: 'View&Filter',
    PRODUCT: 'Product',
    ACTIVITY: 'Activity',
    TO: 'TO',
    CC: 'CC',
    SENDER: 'Sender',
    INCOMING: "Incoming",
    OUTGOING: "Outgoing",
    RELOAD: 'Reload',
    LOGOUT_MSG: "Are you sure you want to log out?",
    SEARCH: "Search",
    UPDATE: "Update",
    SELECTALL: "Select All",
    KEEP_OLD_PASSWORD: "Use Old Password",
    DONT_APPLY: "Do not apply",
    SAVEANDRUN: "Save and run",
  },
  //------- Log in
  LOGIN: {
    MICROSOFT: 'Sign in with Microsoft',
    BACK_TO_LOGIN: 'Switch to account/password login',
    MICROSOFT_LOGIN_TITLE: 'Sign in with Microsoft',
    REFRESH: 'Refresh',
    HINT_1: 'Please logged into your Microsoft account first.',
    HINT_2: 'Press the "Refresh" button to update the screen',
    ACCOUNT: 'Username',
    PWD: 'Password',
    TENANT: 'Tenant',
    TRY: 'Get it free',
    LOGIN: 'LOG IN',
    LOGIN_2: 'Log in UpDay',
    LOGIN_UPCHAT: 'Log in UpChat',
    LOGIN_UPGPT: 'Log in UpGPT',
    GET_VALI_CODE: 'Get Validation Code',
    LOGIN_VALI_CODE: 'Validation Code',
    DESCRIPTION: 'One app to manage everything about your customers.',
    PASSWORD: 'Forgot Password',
    ERROR: 'Please enter username and password',
    ERROR_2: 'Please enter tenant name',
    ERROR_3: 'Incorrect username or password, please try again',
    ERROR_3_VALI_CODE: 'Incorrect username, password or validation code, please try again',
    ERROR_4: 'Please enter username to obtain validation code',
    ERROR_5: 'Incorrect login information',
    SENT_VALI_CODE: 'Validation code has been sent to your email',
    LOGIN_VAL_ERROR: 'Unable to send validation code. Please contact system administrator for detail',
  },
  UPGPT_LOGIN: {
    TITLE: 'Welcome back!',
    SUBTITLE_1: 'Ready to start',
    SUBTITLE_2: 'an amazing conversation with UpGPT?',
    LOGIN: 'Login',
    DISCLAIMER: 'Disclaimer',
    TERMSOFUSE: 'Terms of Use',
    PRIVACYPOLICY: 'Privacy Policy',
    CHANGE_PASSWORD_ALERT: 'To ensure the security of your account, we recommend changing your initial password.',
  },
  FORGET_PASSWORD: {
    TITLE: 'Forgot Password',
    TENANT: 'Tenant',
    ACCOUNT: 'Username',
    MAIL: 'Email',
    ERROR: 'The input data is incorrect, please confirm and try again. ',
    AIRGAPPED: 'Please contact your administrator to reset your password.',
  },
  TRY_IT_FREE: {
    TITLE: 'Get your All-in-one CRM now. Absolutely free.',
    FIRST_NAME: '*First Name',
    LAST_NAME: '*Last Name',
    ORG_NAME: 'Company Name',
    ROLE: 'Job Title',
    PHONE: 'Phone Number',
    MESSAGE: 'Message',
    MESSAGE_2: 'Our team is activating the account for you. You will receive an email when it is ready. Stay tuned! ',
    ERROR: 'Please enter a valid email',
  },
  //------- Bower Title
  Bower_Title: {
    UPCHAT: 'Upday CIC',
    Oppty_Dashboard: 'Opportunity Dashboard - UpDay',
    Case_Dashboard: 'Case Dashboard - UpDay',
    Activity: 'Activity',
    Oppty_List: 'Opportunity List ',
    Oppty: 'Opportunity',
    Deal: 'Deal',
    Contacts_List: 'Contact List',
    Contact: 'Contact',
    Company_List: 'Company List ',
    Company: 'Company',
    Account: 'Account',
    Campaign_List: 'Campaign List - UpDay',
    Campaign: 'Campaign',
    Segment_List: 'Segment List - UpDay',
    Segment: 'Segment',
    Case_List: 'Case List ',
    Case: 'Case',
    Order_List: 'Order List',
    WIADVANCE_Order_List: 'Contract List',
    Order: 'Order',
    WIADVANCE_Order: 'Contract',
    KnowledgeArticle_List: 'Knowledge Article List - UpDay',
    KnowledgeArticle: 'Knowledge Article',
    Setting: 'Setting - UpDay',
    Login: 'Login UpDay',
    LoginUpGPT: 'Login UpGPT',
    ResetPasswordogin: 'Reset Password - UpDay',
    PermissionError: 'Permission Error - UpDay',
    PermissionError_PAGE: 'Not authorized to view the content of this object',
    Portal_PermissionError_PAGE: 'You are not assigned as Portal User, please contact your system administrator.',
    PageNotFoundError: 'Page Not Found - UpDay',
    PageNotFoundError_PAGE: 'This object does not exist, please return to the previous page',
  },
  //---------Rule
  RULE: {
    RULE_R_NUM: 'This field is required, please fill in a number',
    RULE_R_NUM_2: 'Please fill in 17 digits (can include two decimal places)',
    RULE_R_NUM_3: 'Please fill in two digits after the decimal point',
    RULE_R_NUM_4: 'Please fill in 17 digits',
    RULE_R_NUM_5: 'Please fill in positive number',
    RULE_R_NUM_6: 'Please fill in 1-2',
    RULE_R_NUM_7: 'Please fill in numbers or decimals',
    RULE_R_NUM_8: 'Please fill in positive integer',
    RULE_NUM: 'Please fill in a number',
    RULE_R: 'This field is required',
    RULE_R_LASTNAME: 'Contact last name is required',
    RULE_R_LASTNAME_2: 'Last name is required',
    RULE_R_LASTNAME_3: 'User last name is required',
    RULE_R_FIRSTNAME: 'First name is required',
    RULE_R_COMPANY_NAME: 'Company name is required',
    RULE_R_OPPTY_NAME: 'Opportunity name is required',
    RULE_R_OPPTY_Contact: 'Opportunity contact name is required',
    RULE_R_Case_Contact: 'Case contact name is required',
    RULE_R_Case: 'Case name is required',
    RULE_R_SEGMENT: 'Segment name is required',
    RULE_R_CAMPAIGN: 'Campaign name is required',
    RULE_R_TEMPLATE_NAME: 'Template name is required',
    RULE_R_TITLE: 'Title is required',
    RULE_R_ACCOUNT: 'User account is required',
    RULE_HTTP: 'Please fill in http:// or https:// at the beginning',
    RULE_R_PROCESS: 'Process name is required',
    RULE_R_STAGE: 'Stage name is required',
    RULE_R_NAME: 'Name is required',
    RULE_R_ADDRESS: 'Address is required',
    RULE_URL: 'Please fill in the correct URL format',
    RULE_EMAIL: 'Please fill in the correct Email format',
    RULE_PHONE: 'Please fill in the correct phone format',
    RULE_PHOTO: 'Please upload image',
    RULE_CSV: 'Please upload CSV file',
    RULE_FILE: 'Attachment files cannot exceed 20MB in total',
    RULE_FILE_2: 'Photo files cannot exceed 1MB',
    RULE_FILE_3: 'Please keep the files size smaller than {size}MB',
    RULE_FILE_4: 'Photo files cannot exceed 20MB',
    RULE_FILE_5: 'The total number of files cannot exceed 3.',
    RULE_DUE_DATE: 'The expected closed date is required',
    RULE_PROCCESS: 'The process date is required',
    RULE_FORECAST: 'The forecast category is required',
    RULE_REASON: 'The reason for failure is required',
    RULE_NOTE: 'Note content is required',
    RULE_NOTE_1000: 'Note content cannot exceed 1000 words',
    RULE_DATE: 'Please fill in the correct date format YYYY-MM-DD',
    RULE_DATETIME: 'Please fill in the correct format YYYY-MM-DD HH:mm',
    RULE_5: 'Please limit to 5 characters',
    RULE_9: 'Please limit to 9 characters',
    RULE_10: 'Please limit to 10 characters',
    RULE_16: 'Please limit to 16 characters',
    RULE_17: 'Please limit to 17 characters',
    RULE_20: 'Please limit to 20 characters',
    RULE_30: 'Please limit to 30 characters',
    RULE_50: 'Please limit to 50 characters',
    RULE_10_50: 'Please limit to 10 ~ 50 characters',
    RULE_60: 'Please limit to 60 characters',
    RULE_70: 'Please limit to 70 characters',
    RULE_86: 'Please limit to 86 characters',
    RULE_90: 'Please limit to 90 characters',
    RULE_100: 'Please limit to 100 characters',
    RULE_200: 'Please limit to 200 characters',
    RULE_250: 'Please limit to 250 characters',
    RULE_300: 'Please limit to 300 characters',
    RULE_500: 'Please limit to 500 characters',
    RULE_1000: 'Please limit to 1000 characters',
    RULE_10000: 'Please limit to 10000 characters',
    RULE_NULL: 'Please fill in',
    RULE_HHMM: 'time format string should be HH:MM',
    RULE_PROGRESS: 'Please fill in 0-100',
    RULE_CF_1: "Options cannot be repeated",
    RULE_CF_2: 'Options cannot contain ","',
    RULE_ALPHA_NUMERIC: 'Please fill in alphanumeric characters or underscore',
    NO_SPECIAL_SYMBOL: 'Please fill in Chinese/English letters, numbers, underscores, or spaces.',
    RULE_LOWER_ALPHA_NUMERIC: 'Please enter lowercase English letters, numbers or underscores',
  },
  BREADCRUMBS: {
    Contacts: 'Contacts',
    Companies: 'Companies',
    Deals: 'Opportunities',
    Case: 'Cases',
    Campaign: 'Campaigns',
    Segment: 'Segments',
    KnowledgeArticles: 'Knowledge Articles',
    Order: 'Orders',
    WIADVANCE_Order: 'Contract',
  },
  //-----DASHBOARD
  DASHBOARD: {
    TITLE: 'Opportunity Dashboard',
    EXPECTED_REVENUE: 'Expected Revenue',
    SUCCESSFULLY_CLOSED: 'Current closed',
    CURRENT_PERIOD: 'End of period',
    EMAIL_PERFORMANCE: 'Email Performance',
    STAGE_AMOUNT: 'Pipeline Amount by Stage',
    SALES_RANKING: 'Sales Ranking',
    LATEST_OPPTY: 'Recent Opportunities',
    WITHIN_30_DAYS: 'In 30 days',
    BEST_OPPTY: 'Best Opportunities',
    TOP_5: 'Top 5',
    TODAY: 'Today',
    THIS_YEAR: 'This year',
    THIS_SEASON: 'This quarter',
    THIS_MONTH: 'This month',
    THIS_WEEK: 'This week',
    SELECT_DATE: 'Select date',
    //----Headers
    OPPTY_OWNER: 'Opportunity Owner',
    CONTACT_NAME: 'Customer Name',
    OPPTY_NAME: 'Opportunity Name',
    CURRENT_STAGE: 'Current Stage',
    CREATED_TIME: 'Create Time',
    AMOUNT: 'Amount',
    EXPECTED_CLOSE_DATE: 'Expected Closing Date',
    THIS_PERIOD: 'This Period',
    PREVIOUS: 'Previous',
    DIFFERENCE: 'Difference',
    QUANTITY_SENT: 'Email sent',
    READ: 'Email read',
    CLICKED: 'Email clicked',
    UNKNOWN: 'Unknown',
    GO_OPPTY: 'View detail'
  },
  //------- CONTACT LSIT
  CONTACT: {
    TITLE: 'Contact',
    BULK: 'Message',
    SEGMENT: 'Add Segment',
    EMAIL_PUSH: 'Email',
    SMS_PUSH: 'SMS',
    WIADVANCE_REPEAT_EMAIL: 'Warning: Duplicate Email. If you want to proceed with the update, close this window and continue.',
    WIADVANCE_WRONG_CUSTOMER_CODE: "Related Company has no customer code, or there is no mapping company in BC.",
    WIADVANCE_CREATE_CONTACT_FAIL: "Async BC failed, will rollback original data.",
    MESSAGE_DELETE: 'Are you sure you want to delete this contact?',
    MESSAGE_FIRST: 'Please delete',
    MESSAGE_OPPTY: 'related opportunities first',
    MESSAGE_OPPTY_2: 'related opportunities',
    MESSAGE_CASE: 'related cases first',
    MESSAGE_CASE_2: 'related cases',
    MESSAGE_ALL: 'Please delete related opportunities or cases first',
    MESSAGE_ERROR: 'This contact has an opportunity in progress, please re-assign opportunity owner before deleting.',
  },
  ADDSTATICSEGMENT: {
    TITLE: 'Add Static Segment',
    NAME: 'Segment Name',
  },
  CONTACT_DETAIL: {
    TITLE: 'Job Title',
    ORG_NAME: 'Company Nmae',
    OWNER: 'Contact Owner',
    CONTACT_INFORMATION: 'Contact Information',
    FIRST_NAME: 'First Name',
    LAST_NAME: 'Last Name',
    MOBILE_PHONE: 'Mobile Phone',
    OFFICE_PHONE: 'Office Phone',
    BIRTHDAY: 'Birthday',
    ADDRESS: 'Address',
    SUB_ADDRESS: 'Address 2',
    CITY: 'City',
    COUNTRY: 'Country',
    LEVEL: 'Level',
    ZIP_CODE: 'Zip Code',
    DEPARTMENT: 'Department',
    PROVINCE: 'Province',
    RELATED_CAMPAIGN: 'Related Campaign',
    DESCRIPTION: 'Description',
    COMPANY_INFORMATION: 'Company Information',
    ADD_COMPANY_INFORMATION: 'Add Company',
    NO_COMPANY_INFORMATION: 'No Company Information',
    COMPANY_NAME: 'Company Name',
    JURISTIC_PERSON_NAME: 'Juristic Person Name',
    POSITION: 'Position',
    SHAREHOLDING: 'Shareholding',
    FAX: 'Fax',
    ENG_FIRST_NAME: '(ENG)First Name',
    ENG_LAST_NAME: '(ENG)Last Name',
    ENG_TITLE: '(ENG)Job Title',
    ENG_DEPARTMENT: '(ENG)Department',
    INVOICE_RECIEVED: 'Invoice recieve',
    MAILING_ADDRESS: 'Address2',
    //----NOTE
    ADD_NOTE: 'Add Note',
    NO_NOTE: 'No Note',
    //----Oppyt
    NO_DEAL: 'No Opportunity',
    //----Timeline   
    TIMELINE: 'Timeline',
    NO_TIMELINE: 'No Timeline',
    TIMELINE_TITLE: 'Title has been changed to ',
    TIMELINE_DEPARTMENT: 'Department has been changed to ',
    TIMELINE_LEVEL: 'Level has been changed to ',
    TIMELINE_OWNER: 'Owner has been changed to ',
    //----TAB
    DETAIL: 'Detail',
    NOTE: 'Note',
    EMAIL: 'Email',
    SMS: 'SMS',
    UPCHAT: 'Chat History',
    ALL_OPPORTUNITIES: 'Opportunities',
    ALL_CASES: 'Cases',
    DEAL: 'Opportunity Name',
    STAGE: 'Current Stage',
    //----MESSAGE
    MESSAGE: 'Are you sure you want to delete this note?',
    MESSAGE_2: 'Are you sure you want to delete this opportunity?',
    MESSAGE_3: 'Are you sure you want to delete this contact?',
    MESSAGE_4: 'Are you sure you want to copy this note?',
    MESSAGE_5: "Are you sure you want to delete this contact's company information",
    ERROR: 'Please select an image',
    ERROR_2: 'Image must be less than 5MB',
    ERROR_3: 'Please enter the correct format',
    ERROR_4: 'No company name entered',
    ERROR_5: 'This company already exists',
    ERROR_6_1: 'This contact is a customer of ',
    ERROR_6_2: 'please reassign the customer and then delete it',
    ERROR_7: 'Opportunities related to this contact are in progress, please reassign before deleting.',
    ERROR_8: 'This contact has no company information',
  },
  ADD_CONTACT: {
    TITLE: 'Add Contact',
    FIRST_NAME: 'First Name',
    LAST_NAME: 'Last Name',
    SELECT_LABEL: 'Region',
    MOBILE_PHONE: 'Mobile Phone',
    OFFICE_PHONE: 'Office Phone',
    LEVEL: 'Level',
    ORG_NAME: 'Company Name',
    IMAGE: 'Change Photo',
    CN_TITLE: 'Title',
    DEPARTMENT: 'Department',
    ENG_FIRST_NAME: '(ENG)First Name',
    ENG_LAST_NAME: '(ENG)Last Name',
    ENG_TITLE: '(ENG)Title',
    ENG_DEPARTMENT: '(ENG)Department',
    INVOICE_RECIEVED: 'Invoice recieve',
    MAILING_ADDRESS: 'Address 2',
  },
  EDIT_CONTACT: {
    TITLE: 'Edit Contact',
    FIRST_NAME: 'First Name',
    LAST_NAME: 'Last Name',
    SELECT_LABEL: 'Region',
    MOBILE_PHONE: 'Mobile Phone',
    OFFICE_PHONE: 'Office Phone',
    LEVEL: 'Level',
    ORG_NAME: 'Company Name',
    IMAGE: 'Change Photo',
  },
  ADDCONTACTORG: {
    TITLE: 'Add Company',
    COMPANY_NAME: 'Company Name',
    JURISTIC_PERSON_NAME: 'Juristic Person Name',
    POSITION: 'Position',
    SHAREHOLDING: 'Shareholding',
    ERROR: 'This company already exists',
  },
  //------- COMPANY LIST
  COMPANY: {
    TITLE: 'Company',
    VCF: 'VCF',
    //----MESSAGE
    MESSAGE: 'Are you sure you want to delete this company?',
    MESSAGE_2_1: 'Please delete ',
    MESSAGE_2_2: ' related opportunities first',
    MESSAGE_2_3: 'related cases first',
    MESSAGE_3: 'Please delete related opportunities or cases first',
    WIADVANCE_REPEAT_CUSTOMERCODE: "Duplicate Customer Code. Please check the company is exist or not",
  },
  COMPANY_DETAIL: {
    PHONE: 'Phone',
    ADDRESS: 'Address',
    SUB_ADDRESS: 'Address 2',
    WEB: 'Website',
    OWNER: 'Owner',
    INFO: 'Company Information',
    NAME: 'Company Name',
    NAME_EN: '(ENG) Company Name',
    COMPANY_NUMBER: 'Tax ID',
    FAX: 'Fax',
    TYPE: 'Type',
    INDUSTRY: 'Industry',
    EMPLOYEE: 'Employee',
    ANNUAL_REVENUE: 'Annual Revenue',
    REGISTERED_CAPITAL: 'Registered Capital',
    ESTABLISH_DATE: 'Establish Date',
    RELATED_CAMPAIGN: 'Related Campaign',
    DESCRIPTION: 'Description',
    CITY: 'City',
    COUNTRY: 'Country',
    LEVEL: 'Level',
    ZIP_CODE: 'Zip Code',
    PROVINCE: 'Province',
    CLOSING_DATE: 'Closing Date',
    PAYMENT_TERM: 'Payment Term',
    REGULAR_PAYMENT_DATE: 'Regular Payment Date',
    BELONG_GROUP: 'Belong Group',
    //----NOTE
    ADD_NOTE: 'Add Note',
    NO_NOTE: 'No Note',
    //----Oppyt
    NO_DEAL: 'No Opportunity',
    STAGE: 'Current Stage',
    //----primary contact
    CONTACT: 'Primary Contact',
    NO_CONTACT: 'No Primary Contact',
    //----Timeline   
    TIMELINE: 'Timeline',
    NO_TIMELINE: 'No Timeline',
    TIMELINE_EMPLOYEE: 'Employee has been changed to ',
    TIMELINE_REVENUE: 'Annual Revenue has been changed to $',
    TIMELINE_CAPITAL: 'Registered Capital has been changed to $',
    TIMELINE_OWNER: 'Owner has been changed to ',
    TIMELINE_PEOPLE: ' people',
    //----TAB
    DETAIL: 'Detail',
    NOTE: 'Note',
    ALL_OPPORTUNITIES: 'Opportunities',
    ALL_CASES: 'Cases',
    DEAL: 'Opportunity Name',
    //----MESSAGE
    MESSAGE: 'Are you sure you want to delete this note?',
    MESSAGE_2: 'Are you sure you want to delete this opportunity?',
    MESSAGE_3: 'Are you sure you want to delete this company?',
    ERROR: 'Please select an image',
    ERROR_2: 'Image must be less than 5MB',
  },
  ADD_COMPANY: {
    TITLE: 'Add Company',
    ORG_NAME: 'Company Name',
    TYPE: 'Type',
    INDUSTRY: 'Industry',
    IMAGE: 'Logo',
    WEB: 'Website',
    PHONE: 'Phone',
    FAX: 'Fax',
    ADDRESS: 'Address',
    EMPLOYEE: 'Employees',
    COMPANY_NUMBER: 'Company Number',
    COUNTRY: 'Country',
    ZIP_CODE: 'Zip Code',
    CITY: 'City',
    PAYMENT_TERM: 'Payment Term'
  },
  Edit_COMPANY: {
    TITLE: 'Edit Company',
    ORG_NAME: 'Company Name',
    TYPE: 'Type',
    INDUSTRY: 'Industry',
    IMAGE: 'Logo',
    WEB: 'Website',
    PHONE: 'Phone',
    FAX: 'Fax',
    ADDRESS: 'Address',
    EMPLOYEE: 'Employees',
  },
  ADDMAINCONTACT: {
    TITLE: 'Add Company Contact',
    TITLE_2: 'Edit Company Contact',
    NEW_CONTACT: 'Create a new contact',
    OLD_CONTACT: 'Select an existing contact',
    CONTACT_NAME: 'Contact Name',
    FIRST_NAME: 'First Name',
    LAST_NAME: 'Last Name',
    JURISTIC_PERSON_NAME: 'Juristic Person Name',
    POSITION: 'Position',
    SHAREHOLDING: 'Shareholding',
    PRIMARY_CONTACT: 'Primary Contact',
    ERROR: 'If you need to add new contact which never existed in the System, please click the \'+Add\' button above, if not, plase select contact from the contact list',
  },
  MAINCONTACTS: {
    TITLE: 'Company Contact',
    PRIMARY: 'Primary',
    CONTACT_NAME: 'Contact Name',
    JURISTIC_PERSON_NAME: 'Juristic person name',
    POSITION: 'Position',
    SHAREHOLDING: 'Shareholding',
    PHONE: 'Phone',
    MAIL: 'Email',
    ACTIVE: 'Active',
    MESSAGE: 'Are you sure you want to delete this contact? ',
  },
  //------- DEAL LIST
  DEAL: {
    TITLE: 'Opportunity',
    OPPTIES: 'Oppties',
    NO_DEAL: 'No Opportunity',
    NO_DEAL_STAGE: 'No Opportunity Process',
    PROCESS: 'Process',
    //----MESSAGE
    MESSAGE: 'Are you sure you want to delete this opportunity?',
    ERROR: 'Please establish a business process first',
    DELETE_ERROR: 'The following opportunities are closed and cannot be deleted.',
  },
  DEAL_DETAIL: {
    CHANGE_STAGE: 'Change Process',
    REOPEN: 'Reopen',
    NAME: 'Opportunity Name',
    EXPECTED_CLOSE_DATE: 'Expected Closing Date',
    CREATED_ON: 'Created On',
    STATUS: 'Status',
    AMOUNT: 'Amount',
    SCORE: 'Score',
    PROGRESS: 'Progress',
    OWNER: 'Owner',
    CLIENT_NAME: 'Customer',
    NEW_CLIENT: 'Create New Customer',
    CONTACT: 'Primary Contact',
    OPPTY_CONTACT: 'Opportunity Contact',
    NO_OPPTY_CONTACT: 'No Opportunity Contact',
    CLIENT_BUDGET: 'Budget',
    FORECAST_CATEGORY: 'Forecast Category',
    RELATED_CAMPAIGN: 'Related Campaign',
    CUSTOMER_NEEDS: 'Customer Needs',
    PURCHASE_NEEDS_OR_PROCESS: 'Purchase Needs Or Process',
    EXPECT_OR_NEXTSTEPS_OR_OTHERS: 'Expect Or Nextsteps Or Others',
    SALES_NOTES: 'Sales Notes',
    OPPTY_STATUS: 'Opportunity Status',
    INDUSTRY: 'Industry',
    CUSTOMER_SOURCE: 'Customer Source',
    OTHER_CUSTOMER_SOURCE: 'Other Customer Source',
    PROGRESS_2: 'Progress',
    OPPTY_TYPE: 'Opportunity Type',
    SERIAL_NUMBER: 'Opportunity Serial Number',
    ENDACCOUNT: 'End Customer',
    WIADVANCR_CUSTOMER_SOURCE: 'If the ‘Customer Source’ of the opportunity is ‘Business Opportunity’, the Customer Code is required.',
    //----Timeline   
    TIMELINE: 'Timeline',
    NO_TIMELINE: 'No Timeline',
    NO_AMOUNT_CHANGE: 'No Amount Change',
    NO_STAGE_CHANGE: 'No Stage Change',
    NO_FIELD_CHANGE: 'No Field Change',
    NO_ACTIVITY_CHANGE: 'No Activity',
    NO_MAIL: 'No Email',
    NO_SMS: 'No SMS',
    NO_NOTE: 'No Note',
    TIMELINE_AMOUNT: 'Opportunity amount has been changed to $',
    TIMELINE_NAME: 'Opportunity name has been changed to ',
    TIMELINE_FORECAST: 'Forecast category has been changed to ',
    TIMELINE_PROCESS: 'Opportunity process has been changed to ',
    TIMELINE_OWNER: 'Opportunity owner has been changed to ',
    TIMELINE_ECD: 'Expected Closed Date has been changed to ',
    SOON_DUE: " will expire in ",
    SOON_DUE_1: ' days',
    SOON_DUE_2: "has expired for more than ",
    SOON_DUE_3: " days",
    SOON_DUE_4: "today",
    //----TAB
    DETAIL: 'Detail',
    NOTE: 'Note',
    EMAIL: 'Email',
    SMS: 'SMS',
    ALL_CASES: 'Cases',
    //----timeLineType
    TIMELINE_TAB_ALL: 'All',
    TIMELINE_TAB_AMOUNT: 'Amount Change',
    TIMELINE_TAB_STAGE: 'Stage Change',
    TIMELINE_TAB_FIELD: 'Field Change',
    TIMELINE_TAB_MAIL: 'Email',
    TIMELINE_TAB_SMS: 'SMS',
    TIMELINE_TAB_NOTE: 'Note',
    //----MESSAGE
    MESSAGE: 'Are you sure you want to delete this note?',
    MESSAGE_2: 'Are you sure you want to delete this opportunity?',
    MESSAGE_3: 'The closed date will be overwritten, do you still want to reopen?',
  },
  ADD_DEAL: {
    TITLE: 'Add Opportunity',
    NAME: 'Opportunity Name',
    ORG: 'Company',
    CONTACT: 'Contact',
    NO_CONTACT: 'Please input Contact name for search',
    NEW_CONTACT: 'Create a new contact',
    OLD_CONTACT: 'Select an existing contact',
    AMOUNT: 'Amount',
    PROCESS: 'Select Business Process',
    EXPECTED_CLOSE_DATE: 'Expected Closing Date',
    FORCAST: 'Forecast Category',
    DEAL_PROCESS: 'Business Process',
    ERROR: 'An established process must be selected',
    ERROR_2: 'You must select an existing contact or click on a new contact',
    ERROR_3: 'Contact and company must fill in at least one',
  },
  TO_DEAL: {
    NAME: 'Opportunity Name',
    EXPECTED_CLOSE_DATE: 'Expected Closing Date',
    AMOUNT: 'Amount',
    SCORE: 'Score',
    PROGRESS: 'Progress',
    OWNER: 'Owner',
    INFO: 'Basic Information',
    GUIDE: 'Guide',
    BUDGET: 'Budget Confirmed',
    PROBABILITY: 'Probability',
    DESCRIPTION: 'Description',
    DETAIL_PAGE: 'DETAIL',
    IN: 'In',
    LOST: 'Lost',
    CLOSED: 'Closed',
    WIN: 'Won',
    BECAUSE: 'Because of'
  },
  RELATEDCONTACTS: {
    TITLE: 'Contact',
    NEW_CONTACT: 'Create a new contact',
    OLD_CONTACT: 'Select an existing contact',
    FIRST_NAME: 'Contact Name',
    LAST_NAME: 'Contact Last Name',
    NO_CONTACT: 'Please input Contact name for search',
    ADD_CONTACT: 'Add Contact',
    CONTACT_NAME: 'Contact Name',
    ORG_NAME: 'Company Name',
    PHONE: 'Phone',
    MAIL: 'Email',
    ACTIVE: 'Active',
    MESSAGE: 'Are you sure you want to delete this contact? ',
    ERROR: 'If you need to add new contact which never existed in the System, please click the \'+Add\' button above, if not, plase select contact from the contact list'
  },
  CHILD_CASE: {
    TITLE: 'Child Case',
    SUBJECT: 'Subject',
    CONTACT: 'Primary Contact',
    PRIORITY: 'Priority',
    STATUS: 'Stauts',
    GROUP: 'Group',
    TYPE: 'Type',
    OWNER: 'Agent',
    CLOSED_DATE: 'Closed Date',
    ACTIVE: 'Active',
    ADD_CHILD_CASE: 'Add New Child Case',
    NO_CHILD_CASE: 'Not Found',
    SEARCH_CHILD_CASE: 'Please input case subject for search',
    MESSAGE: 'Are you sure you want to delete this child case?',
    ERROR: 'Please select an existing case'
  },
  EDITDEALDATE: {
    TITLE: 'Edit Expected Closing Date',
    NAME: 'Opportunity Name',
    EXPECTED_CLOSE_DATE: 'Expected Closing Date',
  },
  //------- Case
  CASE: {
    TITLE: 'Case',
    CASE: 'Cases',
    NO_CASE: 'No Case',
    NO_CASE_STAGE: 'No Case Process',
    FINISH: 'Closed',
    CLOSED: 'Closed',
    CASE_NUMBER: 'Case Number',
    OWNER: 'Agent',
    //----MESSAGE
    MESSAGE: 'Are you sure you want to delete this case?',
    ERROR: 'Please establish a case process first',
    DELETE_ERROR: 'The following cases are closed and cannot be deleted.',
  },
  CASE_DETAIL: {
    CHANGE_STAGE: 'Change Process',
    CLOSED: 'Closed',
    REOPEN: 'Reopen',
    IN: 'in',
    CONTACT: 'Primary Contact',
    PHONE: 'Incoming Phone',
    EMAIL: 'Incoming Email',
    EMAIL_2: 'Email',
    EXPECTED_CLOSE_DATE: 'Expected Closing Date',
    CREATED_ON: 'Created On',
    PRIORITY: 'Priority',
    STATUS: 'Status',
    OWNER: 'Agent',
    GUIDE: 'Agent Guide',
    DAY: 'Days',
    CASE_NAME: 'Case Name',
    CASE_NUMBER: 'Case Number',
    ORG_NAME: 'Company',
    INCOMING_CONTACT: 'Incoming Contact',
    SOURCE: 'Source',
    GROUP: 'Group',
    TYPE: 'Type',
    CASE_STATUS: 'Status',
    RELATED_CAMPAIGN: 'Related Campaign',
    DESCRIPTION: 'Description',
    DESCRIPTION_2: 'Resolution',
    PARENT_CASE: 'Parent Case',
    //----TAB
    DETAIL: 'Detail',
    NOTE: 'Note',
    SMS: 'SMS',
    PRO: "Products",
    RELATED_ARTICLE: 'Related Article',
    ALL_ARTICLE: 'All Article',
    STAGE_CHANGE: 'Stage Change',
    STATUS_CHANGE: 'Status Change',
    FIELD_CHANGE: 'Field History',
    SUBJECT: 'Subject',
    CLOSED_DATE: 'Closed Date',
    //----Timeline   
    TIMELINE: 'Timeline',
    NO_TIMELINE: 'No Timeline',
    NO_STAGE_CHANGE: 'No Stage Change',
    NO_STATUS_CHANGE: 'No Status Change',
    NO_FIELD_CHANGE: 'No Field Change',
    NO_NOTE: 'No Note',
    NO_MAIL: 'No Email',
    NO_SMS: 'No SMS',
    ADD_NOTE: 'Add Note',
    ADD_PRO: 'Add Product',
    DEL_PRO: 'Delete All',
    CASE_CLOSED: 'Case Closed',
    TIMELINE_OWNER: 'Case owner has been changed to ',
    TIMELINE_NAME: 'Case name has been changed to ',
    TIMELINE_CONTACT: 'Primary Contact has been changed to ',
    TIMELINE_STATUS: 'Case status has been changed to ',
    TIMELINE_PRIORITY: 'Case priority has been changed to ',
    TIMELINE_GROUP: 'Case group has been changed to ',
    TIMELINE_TYPE: 'Case type has been changed to ',
    TIMELINE_DUE_DATE: 'Expected Close Date has been changed to ',
    TIMELINE_CASE_PROCESS: "Case process has been changed to ",
    //----Right
    PRIMARY_CONTACT_CASE: 'Primary Contact Related Cases',
    NO_RELATED_CASE: 'No Related Case',
    RELATED_CONTACT: 'Case Related Contacts',
    NO_RELATED_CONTACT: 'No Related Contact',
    CHILD_CASE: 'Child Cases',
    NO_CHILD_CASE: 'No Related Child Case',
    KNOWLEDGE_ARTICLE: 'Knowledge Article',
    NO_RELATED_ARTICLE: 'No Related Article',
    EXPAND: 'Expand',
    COLLAPSE: 'Collpse',
    REMOVE: 'Remove',
    ADD: 'Add',
    //----MESSAGE
    MESSAGE: 'Are you sure you want to delete this note?',
    MESSAGE_2: 'Are you sure you want to delete this case?',
    MESSAGE_3: 'The closed date will be overwritten, do you still want to reopen?',
    MESSAGE_4: 'Do you want to close the case with all child cases?',
    ERROR: 'Please enter the correct format',
  },
  ADD_CASE: {
    TITLE: 'Add Case',
    NAME: 'Case Name',
    ORG: 'Company',
    CONTACT: 'Contact',
    NO_CONTACT: 'Please input Contact name for search',
    NEW_CONTACT: 'Create a new contact',
    OLD_CONTACT: 'Select an existing contact',
    PHONE: 'Incoming Phone',
    EMAIL: 'Incoming Email',
    SOURCR: 'Source',
    GROUP: 'Group',
    TYPE: 'Type',
    PARENT_CASE: 'Parent Case',
    CATEGORY: 'Category',
    EXPECTED_CLOSE_DATE: 'Expected Closing Date',
    SELECT: 'Select A Case Process',
    PROCESS: 'Case Process',
    ERROR: 'An established process must be selected',
    ERROR_2: 'Please select an existing contact or click on a new contact',
    ERROR_3: 'Please fill in either Contact or Company',
    ERROR_4: 'Please select an existing case',
    USE_AUTONUMBER: "Automatically fill in serial number",
  },
  TO_CASE: {
    NAME: 'Name',
    EXPECTED_CLOSE_DATE: 'Expected Closing Date',
    PRIORITY: 'Priority',
    SCORE: 'Score',
    STATUS: 'Status',
    OWNER: 'Agent',
    INFO: 'Basic Information',
    GUIDE: 'Agent Guide',
    DETAIL_PAGE: 'DETAIL',
    IN: 'In',
    LOST: 'Lost',
    CLOSED: 'Closed',
    WIN: 'Closed',
    SOLVE: 'Solve'
  },
  ADD_CASE_PRODUCT: {
    TITLE: 'Products List',
  },
  //------- Bulk Message
  Bulk_Message: {
    TITLE: 'Outbound',
  },
  //------- Segment
  SEGMENT: {
    TITLE: 'Segment',
    //----MESSAGE
    MESSAGE: 'Are you sure you want to delete this segment?',
    MESSAGE_2_1: 'Please delete ',
    MESSAGE_2_2: ' related campaigns first',
    MESSAGE_3: 'Please delete related campaigns first',
    //----head
    NAME: 'Segment Name',
    TYPE: 'Type',
    PEOPLE: 'Contacts',
    CAMPAIGNS: 'Campaigns',
    OWNER: 'Owner',
    ACTIVE: 'Active',
  },
  ACTIVITY: {
    ADD: 'Add Activity',
    TITLE: 'Activity',
    PRIORITY: 'Priority',
    COMPLETED: 'Completed',
    MARK_COMPLETED: 'Mark As Completed',
    REGARDING: 'Regarding',
    TIME_FRAME: 'Time Frame',
    TYPE: 'Type',
    OWNER: 'Owner',
    SUBJECT: 'Subject',
    PROGRESS: 'Progress',
    REMARK: 'Remarks',
    CONTACT: 'Contact',
    ORG: 'Organization',
    URGENT: 'Urgent',
    IMPORTANT: 'Important',
    MEDIUM: 'Medium',
    LOW: 'Low',
    START_TIME: 'Start Date',
    DUE_TIME: 'Due Date',
    START_DAY: 'Start Day',
    END_DAY: 'Due Day',
    COMPLETED_UNCOMPLETED: 'Incomplete',
    COMPLETED_COMPLETED: 'Completed',
    UNCOMPLETED_ACTIVITY: 'Incomplete Activity',
    TYPE_SETTING: 'Activity Types',
    TYPE_NAME: 'Type Name',
    TYPE_COLOR: 'Color',
    TYPE_ICON: 'Icon',
    ADD_TYPE: 'Add Activity Type',
    ADD_TYPE_BTN: 'Add Type',
    MESSAGE_DELETE: 'Are you sure you want to delete this activity?',
    MONTH: 'Month',
    WEEK: 'Week',
    DAY: 'Day',
    TODAY: "Today",
    MORE: "{0} More",
    MONDAY: "Monday",
    TUESDAY: "Tuesday",
    WEDNESDAY: "Wednesday",
    THURSDAY: "Thursday",
    FRIDAY: "Friday",
    SATURDAY: "Saturday",
    SUNDAY: "Sunday",
    DELETE_ERROR: 'No permission to delete the following activities:',
    NO_CONTACT: "No contact found",
    NO_ORG: "No company found",
    NO_REGARDING: "No case or opportunity found",
    WIADVANCE_NO_REGARDING: "No opportunity found",
    NOT_FOUND_404: "The activity does not exist or has been deleted",
  },
  SEGMENT_DETAIL: {
    CONTACTS: 'Contacts',
    CAMPAIGNS: 'Campaigns',
    TYPE: 'Type',
    OWNER: 'Owner',
    DESCRIPTION: 'Segment Description',
    INFO: 'Segment Information',
    NAME: 'Name',
    RELATED_CAMPAIGN: 'Related Campaign',
    TIME: 'Times',
    DELETE_CONTACT: 'Delete Contact',
    ADD_CONTACT: 'Add Contact',
    CAMPAIGN_Analysis_Chart: 'Campaign Analysis Chart',
    NO_DATA: 'No Available Data',
    CAMPAIGN_Analysis_Statistics: 'Campaign Analysis Statistics',
    NO_CAMPAIGN_DATA: 'No Campaign Data',
    //----TAB
    SETUP: 'Basic Information',
    CONTACT: 'Contact',
    ANALYSIS: 'Analysis',
    C_NAME: 'Name',
    C_ORG: 'Company Name',
    C_PHONE: 'Phone',
    C_MAIL: 'Email',
    C_AMOUNT: 'Total Amount',
    C_OWNER: 'Owner',
    C_ACTIVE: 'Active',
    CAM_NAME: 'Campaign Name',
    CAM_TYPE: 'Type',
    CAM_TIME: 'Campaign Times',
    S_V_S: 'Success vs Sent',
    O_V_S: 'Open vs Success',
    C_V_S: 'Click vs Success',
    S_V_O: 'Success vs Open',
    S_V_C: 'Success vs Click',
    SUCCESS: 'Success',
    SENT: 'Sent',
    OPEN: 'Open',
    CLICK: 'Click',
    END_TIME: 'Last Sent Time',
    //----MESSAGE
    MESSAGE: 'Are you sure you want to delete this segment?',
    MESSAGE_2: 'Are you sure you want to delete this contact?',
    ERROR: 'Please delete related campaigns first',
  },
  ADD_SEGMENT: {
    TITLE: 'Add Segment',
    NAME: 'Segment Name',
    TYPE: 'Type',
    DESCRIPTION: 'Description',
    MESSAGE: 'The new segment has been established, click Confirm to view.',
  },
  EDIT_SEGMENT: {
    TITLE: 'Edit Segment',
    NAME: 'Segment Name',
    TYPE: 'Type',
    DESCRIPTION: 'Description',
  },
  ADDSEGMENTCONTACT: {
    TITLE: 'Segment Contacts',
    ADD_CONTACT: 'Add Contact',
    FIRST_NAME: 'Contact Name',
    ORG_NAME: 'Company Name',
    PHONE: 'Phone',
    MAIL: 'Email',
  },
  //------- CAMPAIGN
  CAMPAIGN: {
    TITLE: 'Campaign',
    //----MESSAGE
    MESSAGE: 'Are you sure you want to delete this campaign?',
    MESSAGE_2: 'Are you sure you want to delete these campaigns?',
    ERROR: 'Please create segments first',
    ERROR_2: 'This campaign is in use',
    ERROR_3: 'The following campaigns are in use',
    //----head
    NAME: 'Campaign Name',
    CHANNEL: 'Channel',
    SEGMENT: 'Segment',
    PEOPLE: 'Contacts',
    OWNER: 'Owner',
    ACTIVE: 'Active',
  },
  CAMPAIGN_DETAIL: {
    STATUS: 'Status',
    CHANNEL: 'Channel',
    PEOPLE: 'Contacts',
    SEGMENT: 'Segment',
    OWNER: 'Owner',
    DESCRIPTION: 'Description',
    NAME: 'Name',
    TYPE: 'Type',
    START_TIME: 'Start Date',
    END_TIME: 'End Date',
    TEMPLATE: 'Select Template',
    EMAIL_CONTENT: 'Email Content：',
    SMS_CONTENT: 'SMS Content：',
    PREVIEW: 'Preview',
    SENTING: 'Sending...',
    NO_O365: 'You have not set up your M365 account. To send emails, go to Settings>Email Sync to set up an M365 account. Thanks!',
    INVALID_O365_TOKEN: 'Your M365 account setup has not been used for a long time.  Please go to Settings>Email Sync to remove existing account and set up again. Thanks!',
    GO_SETTING: 'Setting',
    SUBJECT: 'Subject',
    SMS_CONTENT_2: 'SMS Content',
    CAMPAIGN_Analysis_Chart: 'Campaign Analysis Chart',
    NO_DATA: 'No Available Data',
    CAMPAIGN_Analysis_Statistics: 'Campaign Analysis Statistics',
    NO_CAMPAIGN_DATA: 'No Campaign Data',
    ATTACHMENT: 'Attachment',
    //----TAB
    CAM_NAME: 'Campaign Name',
    END_TIME_2: 'Last Sent Time',
    SETUP: 'Basic Information',
    ANALYSIS: 'Analysis',
    //----MESSAGE
    MESSAGE: 'Are you sure you want to delete this campaign?',
    ERROR: 'Please enter email subject',
    ERROR_2: 'Please enter content',
    ERROR_3: 'Please add a contact to the segment first.',
  },
  ADD_CAMPAIGN: {
    TITLE: 'Add Campaign',
    CHANNEL: 'Channel',
    NAME: 'Campaign Name',
    SEGMENT: 'Segment',
    DESCRIPTION: 'Description',
  },
  EDIT_CAMPAIGN: {
    TITLE: 'Edit Campaign',
    CHANNEL: 'Channel',
    NAME: 'Campaign Name',
    SEGMENT: 'Segment',
    DESCRIPTION: 'Description',
  },
  CAMPAIGNCONTACTLIST: {
    TITLE: 'Campaign Record Contacts',
    ADD_SEG: 'Add Segment',
    Success: 'Successfully sent',
    unSuccess: 'Unsuccessful delivery',
    Open: 'Opened',
    unOpen: 'Unopened',
    Link: 'Link Clicked',
    unLink: 'Not Clicked',
    CONTACT_NAME: 'Contact Name',
    ORG_NAME: 'Company Name',
    PHONE: 'Phone',
    MAIL: 'Email',
  },
  //------- KnowledgeArticles
  KNOWLEDGE_ARTICLE: {
    TITLE: 'Knowledge Article',
    MESSAGE: 'Are you sure you want to delete this article?',
    //----Headers
    H_TITLE: 'Article Title',
    NUMBER: 'Article Number',
    STATUS: 'Status',
    UPDATED_ON: 'Last Edited Time',
    AUTHOR: 'Author',
    ACTIVE: 'Active',
  },
  KNOWLEDGE_ARTICLE_DETAIL: {
    NUMBER: 'Article Number',
    SUBJECT: 'Article Subject',
    STATUS: 'Article Status',
    AUTHOR: 'Author',
    TITLE: 'Title',
    AUTONUMBER: 'Number',
    SUBJECT_1: 'Subject',
    STATUS_2: 'Status',
    KEYWORD: 'Keyword',
    DESCRIPTIONL: 'Description',
    AUTONUMBER_1: 'Automatically Generated',
    //-----BREADCRUMBS   
    KNOWLEDGEARTICLES: 'Knowledge Articles',
    ADD_KNOWLEDGEARTICLES: 'Add Knowledge Articles',
    //----TAB
    DETAIL: 'Detail',
    //----MESSAGE
    MESSAGE: 'Are you sure you want to delete this article?',
    MESSAGE_2: 'Are you sure you want to publish this article?',
    MESSAGE_3: 'Are you sure you want to re-edit this article?',
    ERROR: 'Please enter the content of the article',
  },
  PREFERENCES: {
    PREFERENCE: "Preference",
    ADD_PREFERENCE: "Add",
    TENANT: "Tenant",
    CODE: "Code",
    VALUE: "Value",
    NAME: "Name",
    DESCRIPTION: "Description",
    ACTIVE: "Active",
    MESSAGE: "Are you sure you want to delete this preference?",
    ERROR: "This preference code already exists.",
    ERROR1: "：is not JSON format.",
    RULE_UPPERCASE: "Must be uppercase English or underscore"
  },
  //------- SETTING
  SETTING: {
    TITLE: 'Setting',
    PERSONALSETTING: 'Personal Setting',
    PASSWORDANDLOGIN: 'Password And Login',
    EMAILSYNC: 'Email Sync',
    EMAILTEMPLATE: 'Email Template',
    SMSTEMPLATE: 'SMS Template',
    MANAGEUSERS: 'Manage Users',
    MANAGEGROUPS: 'Manage Groups',
    CUSTOMFIELDS: 'Custom Fields',
    TABLESETTING: 'Custom Views',
    FILTERSETTING: 'Custom Filters',
    PIPELINESTAGESETTING: 'Business Process Setting',
    CUSTOMERSERVICESETTING: 'Customer Service Setting',
    KNOWLEDGEARTICLESUBJECTSETTING: 'Knowledge Article Subject Setting',
    AUTONUMBERSETTING: 'AutoNumber Setting',
    PRODUCTSETTING: 'Product Setting',
    NOTIFICATIONSETTING: "Notice Board Setting",
    PERSONAL: "Personal",
    COMMUNICATION: "Communication",
    COMPANY_SETTING: "Company Setting",
    DATA_VIEW: "Data View",
    CUSTOMER_SERVICE_SETTING: "Customer Service Setting",
    ACTIVITYTYPES: 'Activity Types',
    SMSVENDOR: 'SMS Vendor',
    UPGPTSETTING: 'UpGPT Setting',
    ASSISTANTSETTINGANDUPLOAD: 'AI Assistant Setting',
    GPTTOOLS: 'Tools box',
    UPLOADSTATUS: 'Import/Upload Record',
    TREESETTING: 'Tree Select Setting',
    CALENDARSYNC: "Calendar Sync",
    CUSTOMOPPTYCLOSEDREASON: "Custom Opportunity Closed Reason",
  },
  CUSTOMOPPTYCLOSEDREASON: {
    ADD: "Add Reason",
    ADDREASON: "Add Opportunity Closed Reason",
    NAME: "Closed Reason",
    DESCRIPTION: "Reason description",
    SELECTED: "Can Select",
    ACTIVE: "Active",
  },
  TREESETTING: {
    ADD: 'Add Option',
    TS: 'Tree Select',
    DEL_MSG: 'Are you sure you want to delete this option?',
    OPEN_ALL: 'Expand All',
    CLOSE_ALL: 'Collapse All',
    NO_OPTION: 'There must be at least one option.',
    ERROR: 'This option name already exists.',
    IS_USING: 'This option is in use and cannot be deleted.',
    NO_DATA: 'Please add a new tree option first',
  },
  UPGPT: {
    BASICSETTING: 'Basic Setting',
    QAUPLOAD: 'Q&A Data Upload',
    FOLDERUPLOAD: 'Folder Upload',
    FILEUPLOAD: 'File Upload',
    UPLOADIMG: 'Image Upload',
    CLOUD: 'Cloud Files',
    BASICSETTINGSAVE: 'Save',
    AIASSISTANTNAME: 'AI Assistant Name',
    AIASSISTANTNAME_TIP1: 'To set your AI assistant\'s name',
    AIASSISTANTNAME_TIP2: 'For example: Ann',
    AIASSISTANTROLE: 'AI Assistant Role',
    AIASSISTANTROLE_TIP1: 'To set your AI assistant\'s role',
    AIASSISTANTROLE_TIP2: 'For example: customer service agent for UpDay, a CRM production designed by ART Solutions Limited',
    TOPIC: 'Topic',
    TOPIC_TIP1: 'Give AI assistant a topic to help it rephrase questions better',
    TOPIC_TIP2: 'For example: UpDay CRM',
    TOPICLIMIT: 'Topic Limit',
    TOPICLIMIT_TIP1: 'If topic goes off, AI assistant will redirect conversation back',
    TOPICLIMIT_TIP2: 'For example: technology',
    RESETDATA: 'Reset all Knowledge',
    QAFILEUPLOADMESSAGE: 'Q&A file type should be csv file (UTF-8)',
    FOLDERUPLOADMESSAGE: 'There should be zip file',
    FILEUPLOADMESSAGE: 'There should be txt、pdf、docx or pptx file only',
    FILEUPLOADMESSAGE_IDP: 'There should be pdf、docx、xlsx or pptx file only',
    DELETEALLDATA: 'Are you sure to reset all knowledge ?',
    WRONGTYPEINZIP: 'You should only put txt、CSV、pdf、docx、pptx、jpg、jpeg & png file in zip file',
    WRONGTYPEINCSV: 'Q&A file should be csv file (UTF-8)',
    WRONGTYPEINFILE: 'Only accept txt、pdf、docx & pptx file for File Upload',
    WRONGTYPEINFILE_IDP: 'Only accept pdf、docx、xlsx & pptx file for File Upload',
    WRONGTYPEINIMAGEFILE: 'Only accept  JPG、JPEG、PNG for Image Upload',
    PREFERENCE_WRONG: 'Preferences not set correctly, please contact administrator',
    WAIT: 'Please wait until the file upload is complete and try again.',
    AIASSISTANT_KNOWLEDGE_MANAGEMENT: 'Management of AI assistant knowledge',
    FILE_AMOUNT: 'Total knowledge file amount: ',
    UPDATE_TIME: 'The latest time to update: ',
    NOFILE: 'There is not any knowledge file',
    UPCHAT_INBOX_SETTING: 'UpChat inbox setting',
    TIMEOUT_ERROR: 'AI Assistant is still organizing data into a knowledge base in background, do you want to check the progress in "Import/Upload Records"?',
    TIMEOUT_ERROR_2: 'AI Assistant is still organizing data into a knowledge base in background, do you want to check the progress in Processing File Area?',
    EMBEDDING_WRONG: "Upload failed. Please check that your CSV file is encoded in UTF-8, and whether there are double quotation marks (e.g., 'XXX') in any of the fields in the CSV file header (first row). Please remove them and try uploading again. And also check you files aren't encrypted. Please remove them and try uploading again. If you still cannot upload successfully, please contact UpDay customer support. Thank you!",
    UPLOAD_FAIL: 'Upload Failed',
    FILE: 'File',
    DOWNLOAD: 'Download',
    DOWNLOAD_TXT: 'Download txt file',
    FILE_HAS_BEEN_DELETED: 'File has been deleted, please refresh page',
    WEBSITEANALYSIS: 'Website Analysis',
    WEBSITEANALYSIS_SYNC: 'Website Analysis Synchronize',
    WEBSITEANALYSIS_TIP1: 'Scheduled at midnight daily, use website analysis synchronization with a depth of 1.',
    ADD_URL: 'Add Url',
    EDIT_URL: 'Edit Url',
    URL: 'URL',
    LEVEL: 'Level',
    OVERLIMIT: 'The maximum amount of url is 5',
    ACTION: 'Action',
    DELETE_CHECK: 'Are you sure to delete this url ?',
    START_ANALYSIS: 'Start Analysis',
    DOWNLOAD_ZIP: 'Download zip file',
    BLANK_WEB_INFO: 'You have to analysis first, then you can download the result',
    NO_URL: 'Please fill in at least one URL first',
    FILE_TABLE: 'Linked Knowledge Files',
    NOT_CLEAN: 'Something wrong when resetting, please reset again. If you still cannot reset successfully, please contact UpDay customer support. Thank you!',
    AUTO_DETECT: 'Auto detect',
    REPLY_LANGUAGE: 'Reply Language',
    REPLY_LANGUAGE_TIP: 'AI assistant will reply in language which you choosed',
    TIMEOUT_MESSAGE: 'Due to the large amount of data, please wait a moment. Do you want to check the progress in "Import/Upload Records"? ',
    OVER_SIZE: 'After uploading these folder / files, your storage size will exceed the limit. Please contact us at support@upday.ai to purchase more or remove some files from "Connected Knowledge"',
    NOT_ENOUGH_QUOTA: 'The number of intelligent document analysis attempts has exceeded the limit. Please contact support@upday.ai',
  },
  ACTIVITYTYPES: {
    ERROR: "This activity type is in use and cannot be deleted.",
    ERROR_2: "Must have at least one activity type.",
    ERROR_3: "Default activity types cannot be deleted.",
  },
  SMSVENDOR: {
    VENDOR: "Vendor",
    USER_NAME: "User Name",
    USER_PWD: "User Password",
    DEFAULT: "Default",
    MITAKE: "Mitake",
    DOMAIN: "SmSend API URL",
    TIP: "Please refer to the API document provided by Mitake",
    TIP_2: "Example: https://smsapi.mitake.com.tw/api/mtk/SmSend?CharsetURL=UTF8",
  },
  PERSONALSETTING: {
    BOARD_CONTACT_SYNC: 'Synchronize the information of directors and supervisors from the Commercial Department of the Ministry of Economic Affairs as the contact person',
    FIRST_NAME: 'First Name',
    LAST_NAME: 'Last Name',
    LANGUAGE: 'Language',
    CURRENCY: 'Currency',
    REGION: 'Region',
    OPPTY_DEFAULT_STAGE: 'Opportunity Default Stage',
    CASE_DEFAULT_STAGE: 'Case Default Stage',
    INBOX_NOTIFICATION_SETTINGS: 'Inbox Notification Settings',
    ERROR: 'Please select an image',
    ERROR_2: 'Photos must be less than 5MB',
  },
  PASSWORDANDLOGIN: {
    TITLE: 'Change Password',
    TITLE_2: 'Reset Password',
    MESSAGE: "For the security of your account, please change your password regularly. And increase the password complexity, don't use easy-to-guess strings. Example: birthday, phone number...etc",
    ERROR: 'Please confirm that the password is 8-30 characters long and contains uppercase and lowercase English letters, numbers, and special symbols',
    ERROR_2: 'The entered password does not match the new password, or the password format is incorrect',
    ERROR_3: 'Please enter your current password',
    ERROR_4: 'New Password and Confirm Password are required',
    ERROR_5: 'Please re-enter the password',
    ERROR_6: 'Failed to change password, please try again',
    ERROR_7: 'The new password and the confirmation password are different, please re-enter',
    ERROR_8: 'Failed to reset password, please try again. Cause:',
    ERROR_9: 'This reset password link has expired',
    OLD_PASSWORD: 'Current Password',
    NEW_PASSWORD: 'New Password',
    NEW_PASSWORD_2: 'Confirm Password',
  },
  EMAILSYNC: {
    TEXT: 'Connected Accounts',
    TEXT_2: 'Here is your connected M365 accounts',
    NO_CONNECT: 'No Connected M365 Account',
    ADD_ACCOUNT: 'Add Account',
    MESSAGE: 'Are you sure you want to delete this M365 account setting?',
    ERROR: 'Delete failed, please try again',
    DIALOG: 'Link M365 Account',
    DIALOG_2: 'Click add button will redirect you to M365 login page.  Once succeed, you will be redirected back to setting page',
    DIALOG_S: 'Successfully Connect M365 Account',
    DIALOG_S2: 'You have successfully connect to M365 account.  Please verify you account email address in Email Sync section.  Thanks!',
    START_SYNC: "Start Sync",
    SYNCING: "Synchronizing",
    H1: "Email synchronization processing:",
    H1_1: "All emails are synchronized to UpDay",
    H1_2: "Only the specified emails are synced to UpDay",
    H1_3: "Open",
    H1_4: "Close",
    H2: "When to start synchronization:",
    H2_1: "Today",
    H2_2: "within 1 month",
    H2_3: "Within 3 months",
    H2_4: "Within 6 months",
    H2_5: "Custom",
    H3: "Synchronously sent and sent Email objects:",
    H3_1: "Only UpDay contacts",
    H3_2: "Everyone",
    H4: "Email restriction settings:",
    H5: "Set blacklist Email or domain",
    H6: "Blacklist Email",
    H7: "Blacklist Domains",
    H8: "Acceptable Domains",
    TOO_MUCH_INBOX: "The number of email in inbox has exceeded the maximum of 9999, please select a shorter period and try again.",
    TOO_MUCH_SENTBOX: "The number of email in sentbox has exceeded the maximum of 9999, please select a shorter period and try again.",
  },
  EMAILTEMPLATE: {
    TEMPLATE: 'Template',
    ADD_TEMPLATE: 'Add Template',
    EDIT_EMAIL_TEMPLATE: 'Edit Email Template',
    ADD_EMAIL_TEMPLATE: 'Add Email Template',
    NAME: 'Template Name',
    SUBJECT: 'Subject',
    //Header
    ADD_DATE: 'Created Time',
    END_TIME: 'Last Edited Time',
    ACTIVE: 'Active',
    MESSAGE: 'Are you sure you want to delete it?',
    ERROR: 'Please fill in the name of the new template!',
  },
  SMSTEMPLATE: {
    TEMPLATE: 'Template',
    ADD_TEMPLATE: 'Add Template',
    EDIT_SMS_TEMPLATE: 'Edit SMS Template',
    ADD_SMS_TEMPLATE: 'Add SMS Template',
    NAME: 'Template Name',
    //Header
    ADD_DATE: 'Created Time',
    END_TIME: 'Last Edited Time',
    ACTIVE: 'Active',
    MESSAGE: 'Are you sure you want to delete it?',
  },
  MANAGEUSERS: {
    RESET_PASSWORD: 'Reset Password',
    RESET_LINK_DESC: 'Please provide the reset password link below to the user:',
    RESET_LINK_ERROR: 'Unable to generate the reset password link. Please try again later.',
    INVITED_TITLE: 'User Invited',
    INVITED_DESC: 'Please provide the username and password below to the user. The password cannot be viewed again after closing.',
    INVITED_USERNAME: 'Username',
    INVITED_PASSWORD: 'Password',
    USERMANAGER: 'Manager',
    SEAT: 'Seats Available',
    ACTIVATED: 'Activated',
    UNACTIVATED: 'Deactivated',
    INVITE_USERS: 'Invite Users',
    MANAGER: 'Manager',
    STAFF: 'Staff',
    MAIL_TITLE: "Email",
    MAIL: 'Email will be used as login account',
    USER: 'User',
    FIRST_NAME: 'First Name',
    LAST_NAME: 'Last Name',
    USER_ROLE: 'Identity',
    INVITE: 'Invite',
    EDIT_USER: 'Edit User',
    //Header
    NAME: 'Name',
    ROLE: 'Role',
    IS_SERVICE_AGENT: 'Service Agent',
    IS_TECH_USER: 'Technical Staff',
    IS_PORTAL_USER: 'Portal User',
    IS_PORTAL_USER_ADD: 'Set as Portal User',
    IS_VIEW_ONLY_USER: 'View Only Staff',
    LAST_TIME: 'Last login time',
    ACTIVE: 'Active',
    MESSAGE: 'Are you sure you want to deactivate this user?',
    MESSAGE_2: 'Are you sure you want to restart this user?',
    ERROR: 'Sorry, the maximum number of users has been reached! To add new ones, set existing contacts to inactive.',
    ERROR_2: 'Sorry, you do not have sufficient permissions!',
    ERROR_3: 'Account already exists.',
    ERROR_4: 'There must be at least one admin user',
  },
  MANAGEGROUPS: {
    ADD_GROUP: 'Add Group',
    ADD_GPT_GROUP: 'New',
    EDIT_GPT_GROUP: 'Edit',
    GROUP: 'Group',
    NAME: 'Name',
    TYPE: 'Type',
    MEMBER: 'Member',
    NAME_HINT: 'The name cannot be repeated',
    TYPE_HINT: 'This field is required',
    MEMBER_HINT: 'Group must have at least one member',
    //Header
    ACTIVE: 'Active',
    ERROR: 'Sorry, you do not have sufficient permissions!',
    ERROR_2: 'This group name already exists.',
    MESSAGE: 'Are you sure you want to delete this group?',
    MEMBER_SEARCH: 'Search members',
  },
  CUSTOMFIELDS: {
    SELECT_PROCESS: 'Select Process',
    SELECT_PAGE: 'Select Page',
    ADD_FIELD: 'Add Field',
    EDIT_OPTION: 'Edit Field',
    OPTION: 'Option',
    TREE_OPTION: 'Tree Select',
    ADD_CF: 'Add CustomField',
    P_SELECT_PAGE: 'Please select a using page',
    SELECT_O_PROCESS: 'Please select a opportunity process',
    SELECT_C_PROCESS: 'Please select a case process',
    SELECT_MESSAGE: 'Select one or more fields for the form.',
    NAME: 'Field Name',
    TYPE: 'Field Type',
    DESCRIPTIONS: 'Field Description',
    MANDATORY: 'Mandatory',
    //Header
    ACTIVE: 'Active',
    NO_OPPTY_STAGE: 'No Opportunity Process',
    NO_CASE_STAGE: 'No Case Process',
    ERROR: 'Please keep at least two options',
    ERROR_2: 'Please enter the correct content',
    ERROR_3: 'Please enter at least two options',
    ERROR_4: 'Please add a opportunity process first',
    ERROR_5: 'Please add a case process first',
    ERROR_6: 'Please enter new options and press Enter',
    MESSAGE: 'Are you sure you want to delete it?',
  },
  TABLESETTING: {
    PAGE: 'Select Page',
    PROCESS: 'Select Process',
    NEW: 'New View',
    COPY: 'Copy Current View',
    DEFAULT: 'Default',
    NAME: 'Name',
    MESSAGE: "Are you sure you want to delete it?",
    SET: 'Setting',
    FIELD: 'Field',
    SEQ: 'Sequence',
    TITLE: 'Edit Current View',
  },
  FILTERSETTING: {
    FILTER: 'Filter',
    ADD: "Add Filter",
    EDIT: "Edit Filter",
    COPY: "Copy Filter",
    VISIBILITY: "Visibility",
    VISIBILITY_0: "Private",
    VISIBILITY_1: "Public",
    DEFAULT: 'Default',
    FILTERFIELD: "Select Field",
    PERSONAL_SETTING: 'Personal Setting',
    SYSTEM_SETTING: 'System Setting',
    CONDITION: "Select Condition",
    ADD_CONDITION: "Add Condition",
    DATE: "Select Date",
    CAMPAIGN: 'Select Campaign',
    SEG: 'Select Segment',
    PRODUCT: 'Select Product',
    PARENT_CASE: 'Select Parent Case',
    TEXT: "Fill In Text",
    NUM: "Fill In Number",
    OPT: "Choose options",
    TRUE: "True",
    FALSE: "False",
    INPUT_TO_SEARCH: 'Please input company name for search',
    INPUT_CONTACT_TO_SEARCH: 'Please input contact name for search',
    INPUT_PRODUCT_TO_SEARCH: 'Please input product name for search',
    INPUT_PARENT_CASE_TO_SEARCH: 'Please input parent case for search',
    ERROR: 'Please at least add one Condition',
    ERROR2: 'Please select a field',
    ERROR3: 'Please confirm the search condition',
    MESSAGE: 'Are you sure you want to delete it?',
    PUBLIC: 'Public',
    PRIVATE: 'Private',
    CS: 'Custom Setings',
    NO_FILTER: 'No Filter',
    DELETED_DATA: 'Deleted Data',
  },
  OP_TEXT: {
    CONTAINS: "Contains",
    NOT_CONTAINS: "Not Contains",
    IS_EMPTY: "Is Empty",
    NOT_EMPTY: "Not Empty",
  },
  OP_NUM: {
    EQUAL: "Equal",
    EQUAL_LESS: "Equal Or Less Than",
    EQUAL_LARGER: "Equal Or Larger Than",
    LESS: "Less Than",
    LARGER: "Larger Than",
  },
  OP_DATE: {
    ON: "On",
    ON_OR_AFTER: "On Or After",
    ON_OR_BEFORE: "On Or Before",
    TODAY: "Today",
    YESTERDAY: "Yesterday",
    TOMORROW: "Tomorrow",
    NEXT_7_DAYS: "Next 7 Days",
    LAST_7_DAYS: "Last 7 Days",
    THIS_WEEK: "This Week",
    THIS_MONTH: "This Month",
    THIS_QUARTER: "This Quarter",
    THIS_YEAR: "This Year",
    NEXT_WEEK: "Next Week",
    NEXT_MONTH: "Next Month",
    NEXT_QUARTER: "Next Quarter",
    NEXT_YEAR: "Next Year",
    LAST_WEEK: "Last Week",
    LAST_MONTH: "Last Month",
    LAST_QUARTER: "Last Quarter",
    LAST_YEAR: "Last Year",
  },
  PIPELINESTAGESETTING: {
    ADD: 'Add Process',
    WORRY: "Don't worry about your team not following business processes or SOPs! As long as you set the business process here, the system will guide your team towards better results.",
    ERROR: 'This process has been used by other opportunities, please replace the process and delete it.',
    ERROR_2: 'This process has been used by other cases, please replace the process and delete it.',
    MESSAGE: 'Custom View in this process will be delete too, Are you sure you want to delete it?',
    DEFAULT_PROCESS: 'System Default Stage'
  },
  CUSTOMERSERVICESETTING: {
    ADD: 'Add Option',
    TYPE: 'Case Type',
    GROUP: 'Case Group',
    CATEGORY: 'Case Category',
    ADD_OPTION: 'Add Customer Service Options',
    USEING_TYPE: 'Please select the using type',
    NAME: 'Option Name',
    OPTION_DESCRIPTION: 'Option Description',
    //----TAB
    ACTIVE: 'Active',
    MESSAGE: 'Are you sure you want to delete it?',
    ERROR_1: "This case group is in use",
    ERROR_2: "This case type is in use",
  },
  KNOWLEDGEARTICLESUBJECTSETTING: {
    ADD_SUBJECT: 'Add Subject',
    ADD: 'Add Knowledge Article Subject',
    NAME: 'Subject Name',
    DESCRIPTION: 'Subject Description',
    ACTIVE: 'Active',
    MESSAGE: 'Are you sure you want to delete it?',
  },
  AUTONUMBERSETTING: {
    CASE_SETTING: 'Case Setting',
    PERFIX: 'Prefix',
    SUFFIX: 'Suffix',
    RECODR_TYPE: 'Record Type',
    NUMBER_FORMAT: 'Number Format',
    START_NUMBER: 'Start Number',
    CURRENT_NUMBER: 'Current Number',
    RESET: 'Reset Current Number',
    ACTIVATED: 'Activated',
    UNACTIVATED: 'deactivated',
    KA_SETTING: 'Knowledge Article Setting',
    TIME_MODE: 'Timestamp Mode',
    NUMBER_MODE: 'Number Mode',
    NO_RECORD: 'No Record',
    MESSAGE: 'The current number is less than the starting number, do you want to reset the current number?',
    RULE: 'Please limit to ',
    RULE_1: ' characters',
    AUTO: 'Autofill Title',
  },
  PRODUCTSETTING: {
    TYPE: 'Porduct Type',
    DP: 'General Product',
    SP: 'Service Product',
    LP: 'License Product',
    PRODUCT: 'Product',
    CATEGORY: 'Category',
    SERIES: 'Series',
    NAME: 'Name',
    PRODUCTCODE: 'Product Code',
    PRICR: 'Price',
    COST: 'Cost',
    DESCRIPTIONL: 'Description',
    ADD_PRODUCT: 'Add Product',
    EDIT_PRODUCT: 'Edit Product',
    ADD_PRODUCT_2: 'Add Product Category',
    EDIT_PRODUCT_2: 'Edit Product Category',
    ADD_PRODUCT_3: 'Add Product Series',
    EDIT_PRODUCT_3: 'Edit Product Series',
    MESSAGE: 'Are you sure you want to delete it?',
    ERROR: 'This product is in use',
    ERROR_2: 'This category is in use',
    ERROR_3: 'This series is in use',
  },
  NOTIFICATIONSETTING: {
    ADD_NOTICE: "Add",
    NOTICE: "Notice",
    NOTICEBOARD: "Notice Board",
    TITLE: "Title",
    CONTENT: "Content",
    STATUS: "Status",
    ACTIVE: "Active",
    MESSAGE: "Are you sure you want to delete it?",
    MESSAGE2: "Are you sure? It will show again next login.",
    ACTIVATED: "Activated",
    UNACTIVATED: "Unactivated",
    ERROR: "This title is in use",
    TIMER: "Notice cycle time",
    SECONDTIMES: "second/time"
  },
  INBOX_NOTIFICATION_SETTINGS: {
    ALLOW_WEB_PUSH: "Allow Web Push",
    ALLOW_FOLLOW: "Remind me when records I'm following change",
    ALLOW_MENTION: "Remind me when I'm @mentioned",
    ALLOW_REPLY: "Remind me when a post I'm subscribed to replies to",
    ALLOW_EMOJI: "Remind me when a post I subscribe to is liked",
  },
  CALENDAR_SYNC_SETTINGS: {
    SELECT_CALENDAR: "Select calendar",
    SYNC_TYPE: "Select sync type",
    SYNC_AS: "Sync as type",
    PRIVATE_EVENTS: "Private events",
    SELECT_TO_SYNC: "Sync activities type to calendar",
    SYNC_REGARDING: "Sync regarding data",
    PRIVATE_EVENTS_0: "Don't sync",
    PRIVATE_EVENTS_1: "Sync",
    SYNC_REGARDING_0: "Don’t include regarding info",
    SYNC_REGARDING_1: "Include regarding info",
    NO_SELECT_TYPE: "No selected type.",
    STOP_SYNC: "Stop Sync",
    CONNECT_SUCCESS: "You have successfully connect to M365 account.  Please verify you account email address in Calendar Sync section.  Thanks!",
    SYNC_TYPE_ONE_0: "One-Way Sync",
    SYNC_TYPE_ONE_1: "UpDay activities sync to calendar",
    SYNC_TYPE_ONE_2: "Only edits to UpDay activities will sync back to UpDay",
    SYNC_TYPE_TWO_0: "Two-Way Sync",
    SYNC_TYPE_TWO_1: "UpDay activities sync to calendar",
    SYNC_TYPE_TWO_2: "Calendar events sync to UpDay as activities",
  },
  //--------Common
  CHANGEOWNER: {
    TITLE: 'Change Agent',
    TITLE_2: 'Change Author ',
    TITLE_3: 'Change Owner',
  },
  CASECARD: {
    TITLE: 'Case',
    NO_CASE: 'No Case',
    CASE_NUMBER: 'Case Number',
  },
  PRODUCTTABLE: {
    NO_PRO: 'No Product',
    MESSAGE: 'Are you sure you want to delete this product?',
  },
  PRODUCTLINEITEM: {
    QUANTITY: 'quantity',
    QUANTITY_H: 'Quantity',
    QUANTITY_D: 'Total Quantity',
    DAYS: "Days",
    TAX: 'Tax',
    TAX_H: 'Tax',
    UNIT: 'unit',
    DISCOUNT: 'discount',
    DISCOUNT_H: 'Discount',
    AMOUNT: 'amount',
    AMOUNT_H: 'Amount',
    SUBTOTAL_LIST_PRICE: 'subtotal list price',
    TOTAL_DISCOUNT: 'total discount',
    SUBTOTAL_AMOUNT: 'subtotal amount',
    SALES_TAX: 'sales tax',
    TOTAL: 'Total',
    TOTAL_PRODUCTS: 'total products',
    TAX_INCLUSIVE: 'Tax inclusive',
    TAX_EXCLUSIVE: 'Tax exclusive',
    NO_TAX: 'No tax',
    SYSTEM_COMPUTE: 'system compute',
    MANUAL_INPUT: 'manual input',
    DISCOUNT_DATA: 'discount data',
    TAX_DATA: 'tax data',
    OTHER_CHARGES: 'Other Charges',
    ENABLE_TRQ: 'Enable Time Range Quantity',
    FROM: 'From',
    TO: 'To',
    FROMTOERROR: 'Can not only fill in a single date.',
    OC_DISCOUNT: 'total other charges',
    OC: 'other charges',
  },
  CASETABLE: {
    NO_CASE: 'No Case',
    MESSAGE: 'Are you sure you want to delete this case?',
    SUBJECT: 'Subject',
    CONTACT: 'Primary Contact',
    PRIORITY: 'Priority',
    STATUS: 'Status',
    GROUP: 'Group',
    TYPE: 'Type',
    OWNER: 'Agent',
    CLOSED_DATE: 'Closed Date',
  },
  OPPTYCARD: {
    TITLE: 'Opportunity',
    NO_OPPTY: 'No Opportunity',
    EXPECTED_CLOSE_DATE: 'Expected Closing Date',
  },
  CUSTOMFIELD: {
    TITLE: 'Custom Field',
    NO_DATA: 'No Custom Field',
  },
  EMAILEDITOR: {
    RECIPIENT: 'Recipient',
    COPY: 'Copy',
    ATTACHMENT: 'Attachment',
    SUBJECT: 'Subject',
    SEND: 'Send',
    CLEAR: 'Clear',
    TEMPLATE: 'Email Template',
    NO_O365: 'You have not set up your M365 account. To send emails, go to Settings>Email Sync to set up an M365 account. Thanks!',
    INVALID_O365_TOKEN: 'Your M365 account setup has not been used for a long time.  Please go to Settings>Email Sync to remove existing account and set up again. Thanks!',
    NO_DATA: 'No Available Data',
    GO_SETTING: 'Setting',
    ERROR: 'Attachment files cannot exceed 20MB in total',
    ERROR_2: 'This email address is not in the correct format',
    ERROR_3: 'Please fill in the fields before sending the Email',
  },
  SMSEDITOR: {
    ADD: 'Add',
    RECIPIENT: 'Recipient',
    NUMBER: 'Mobile Number',
    ENTER: 'Enter mobile number',
    SEND: 'Send',
    CLEAR: 'Clear',
    TEMPLATE: 'SMS Template',
    ERROR: 'Please fill in the fields before sending the SMS',
    ERROR_2: 'Please enter the correct format',
  },
  LOSEREASON: {
    TITLE: 'Case Closed',
    TITLE_2: 'Select Lose Reason',
    TITLE_3: 'Congrations for the great win!',
    CASE_NAME: 'Case Name',
    CONTACT_NAME: 'Primary Contact Name',
    OPPTY_NAME: 'Opportunity Name',
    CUSTOMER_NAME: 'Customer Name',
    CLOSE_DATE: 'Closed Date',
    CLOSE_REASON: 'Closed Reason',
    STATUS: 'Status',
    CLOSED: 'Closed',
    OPEN: 'Open',
    AMOUNT: 'Amount',
    LOSE: 'Lose Reason',
    WIN: 'Won',
  },
  EMAILCAMPAIGNDIALOG: {
    TITLE: 'Email Preview',
    SUBJECT: 'Subject',
    ATTACHMENT: 'Attachments',
    MESSAGE: 'The Email is being sent, click OK to go to the event page to check the delivery progress'
  },
  SMSCAMPAIGNDIALOG: {
    TITLE: 'SMS Preview',
    SMS_CONTENT: 'SMS Content',
    MESSAGE: 'The SMS is being sent, click OK to go to the event page to check the delivery progress'
  },
  ADDPROCESSDIALOG: {
    EDIT: 'Edit Process',
    ADD_OPPTY: 'Add Opportunity Process',
    ADD_CASE: 'Add Case Process',
    NAME: 'Process Name',
    PAGE: 'Using Page',
    STAGE_NAME: 'Stage Name',
    PROBABILITY: 'Probability',
    FINISH_DAY: 'Expected Days',
    GUIDE: 'Guide',
    COLOR: 'Color',
    DAY: 'Days',
    ERROR: 'Stage cannot be null',
    ERROR_2: 'This step already been used, so it cannot be deleted.',
    MESSAGE: 'Are you sure you want to delete the step?',
  },
  ADDNOTE: {
    TITLE: 'Add Note',
    TITLE_2: 'Edit Note',
    CONTENT: 'Please enter content',
  },
  EMAILATTACHMENTSDIALOG: {
    TITLE: 'Email attachment',
  },
  EMAILCONTACTSDIALOG: {
    TITLE: 'Related Contacts',
  },
  EMAILOPPTIESDIALOG: {
    TITLE: 'Related Opportunities',
    NO_OPPTY: 'No Opportunity',
    EXPECTED_CLOSE_DATE: 'Expected Close Date : ',
  },
  REDIRECTDIALOG: {
    NEW_CONTACT: 'View new contact',
    NEW_ORG: 'View new company',
    NEW_OPPTY: 'View new opportunitiy',
    NEW_CASE: 'View new case',
    NEW_ORDER: 'View new order',
    NEW_CONTRACT: 'View new contract',
  },
  //------- List.js
  LEVELLIST: { 0: "Staff", 1: "Manager", 2: "Director", 3: "C-Level", 4: "Owner" },
  KASTATUSLIST: {
    PUBLISHED: 'Published',
    WAIT_PUBLISH: 'Awaiting Release',
    IN_REVIEW: 'Under Review',
    AUTHORING: 'Authoring',
  },
  CASESTATUSLIST: {
    OPEN: 'Open',
    PENDING: 'Pending',
    WAIT_CUSTOMER: 'Wait customer',
    WAIT_3RD_PARTY: 'Wait 3rd party',
    RESOLVED: 'Resolved',
    CLOSED: 'Closed',
  },
  OPPTYSTATUSLIST: {
    OPEN: 'OPEN',
    WON: 'WON',
    LOSE: 'LOSE',
  },
  CAMPAIGNTYPELIST: {
    ADVERTISEMENT: 'Advertisement',
    DIRECT_MARKETING: 'Direct Marketing',
    MARKETING_EVENT: 'Marketing Event',
    JOINT_MARKETING: 'Joint Marketing',
    OTHERS: 'Others',
  },
  CASEPRIORITYLIST: {
    VERY_HIGH: 'Very High',
    HIGH: 'High',
    MEDIUM: 'Medium',
    LOW: 'Low',
    VERY_LOW: 'Very Low',
  },
  CASESOURCELIST: {
    EMAIL: 'Email',
    WEB_FORM: 'Web Form',
    WEB_CHAT: 'Web Chat',
    PHONE: 'Phone',
    STORE: 'Store',
    OUTBOUND: 'Outbound',
    OTHERS: 'Others',
  },
  CLOSECASEREASONLIST: {
    RESOLVED: 'Resolved',
    ALTERNATIVE: 'Alternative solution',
    NO_SOLUTION: 'No solution',
    NO_RESPONSE: 'Customer no response',
    NOT_AN_ISSUE: 'Not an issue',
  },
  CLOSEREASONLIST: {
    null: 'Open',
    0: 'Reopen',
    1: 'Won',
    2: 'Lose to competitors',
    3: "Customer do nothing",
  },
  NUMBERTYPELIST: {
    3: 'Three digits',
    4: 'Four digits',
    5: 'Five digits',
    6: 'Six digits',
    7: 'Seven digits',
    8: 'Eight digits',
    9: 'Nine digits',
    10: "Ten digits",
    11: 'Eleven digits',
    12: 'Twelve digits',
    13: 'Thirteen digits',
    14: 'Fourteen digits',
    15: 'Fifteen digits',
  },
  SEGMENT_TYPELIST: {
    STATIC: 'Static',
    DYNAMIC: 'Dynamic',
  },
  STAGEDEFCOLORLIST: {
    0: 'Red',
    1: 'Orange',
    2: 'Yellow',
    3: 'Green',
    4: 'Blue',
    5: 'Purple',
  },
  INDUSTRYLIST: {
    0: 'Agriculture, Forestry, Fishing, Animal Husbandry',
    1: 'Mining and Quarrying',
    2: 'Manufacturing',
    3: 'Electricity and Gas Supply',
    4: 'Water Supply and Remediation Activities',
    5: 'Construction',
    6: 'Wholesale and Retail Trade',
    7: 'Transport and Storage',
    8: 'Accommodation and Food Service Activities',
    9: 'Information and Communication',
    10: 'Financial and Insurance Activities',
    11: 'Real Estate Activities',
    12: 'Professional, Scientific and Technical Activities',
    13: 'Support Service Activities',
    14: 'Public Administration and Defence; Compulsory Social Security',
    15: 'Education',
    16: 'Human Health and Social Work Activities',
    17: 'Arts, Entertainment and Recreation',
    18: 'Other Service Activities',
  },
  ORGTYPELIST: {
    0: 'Branches of foreign company',
    1: 'Offices of foreign company',
    2: 'Branches established by domestic company',
    3: 'Cooperation',
    4: 'Partnership',
    5: 'Limited Company',
    6: 'Limited Partnership',
    7: 'gmbh & co. kg',
    8: 'Others',
    9: 'Limited Company by Shares',
    10: 'Unlimited Company',
    11: 'Sole Proprietorship',
  },
  AGENTSTATUSLIST: {
    ONLINE: 'Online',
    AWAY: 'Away',
    BUSY: 'Busy',
    OFFLINE: 'Offline',
  },
  CONTACTSFIELDLIST: {
    created_on: 'Created on',
    created_by: 'Created By',
    updated_on: 'Updated On',
    updated_by: 'Updated By',
    owner: 'Owner',
    orgs: 'Company Name',
    full_name: 'Contact Name',
    english_full_name: '(ENG)Contact Name',
    english_title: '(ENG)Title',
    english_department: '(ENG)Department',
    invoice_recieved: 'Invoice recieve',
    mailing_address: 'Billing Address 2',
    total_amount: 'Total amount',
    title: 'Title',
    email: 'Email',
    mobile_phone: 'Mobile Phone',
    office_phone: 'Office Phone',
    description: 'description',
    department: 'Department',
    birthdate: 'Birthdate',
    level: 'Level',
    fax: 'Fax',
    facebook: 'Facebook',
    linkedin: 'Linkedin',
    instagram_id: 'Instagram',
    line_id: 'Line',
    billing_address: 'Billing Address',
    city: 'City',
    country: 'Country',
    zip_code: 'Zip Code',
    province: 'Province',
    primary_campaign_id: 'Related Campaign',
    seg: 'Segment'
  },
  ORGSFIELDLIST: {
    created_on: 'Created on',
    created_by: 'Created By',
    updated_on: 'Updated On',
    updated_by: 'Updated By',
    owner: 'Owner',
    name: 'Company Name',
    website: 'Website',
    company_number: 'Tax ID',
    main_phone: 'Phone',
    industry: 'Industry',
    employee: 'Employees',
    establish_date: 'Establish Date',
    annual_revenue: 'Annual Revenue',
    registered_capital: 'Registered Capital',
    fax: 'Fax',
    billing_address: 'Billing Address',
    sub_address: 'Address 2',
    city: 'City',
    country: 'Country',
    zip_code: 'Zip Code',
    province: 'Province',
    total_amount: 'Total amount',
    organization_type: 'Type',
    primary_campaign_id: 'Related Campaign',
    description: 'description',
    name_en: '(ENG) Company Name',
    closing_date: 'Closing Date',
    payment_term: 'Payment Term',
    regular_payment_date: 'Regular Payment Date',
    belong_group: 'Belong Group',
  },
  OPPTYSFIELDLIST: {
    created_on: 'Created on',
    created_by: 'Created By',
    updated_on: 'Updated On',
    updated_by: 'Updated By',
    owner: 'Opportunity Owner',
    name: 'Opportunity Name',
    amount: 'Amount',
    expected_close_date: 'Expected Close Date',
    closed_date: 'Closed Date',
    closed_reason: 'Closed Reason',
    status: 'Status',
    forecast_category: 'Forecast Category',
    customer_needs: 'Customer Needs',
    customer_budget: 'Customer Budget',
    budget_confirmed: 'Budget Confirmed',
    primary_campaign_id: 'Related Campaign',
    stage_type: 'Opportunity Process',
    oppty_contact: 'Contact Name',
    current_stage: 'Current Stage',
    primary_contact: 'Primary Contact',
    description: 'description',
    filter_oppty_contact: 'Contact Name(Person)',
    filter_oppty_org: 'Contact Name(Organization)',
    tax_option: 'Tax Option',
  },
  CASESFIELDLIST: {
    created_on: 'Created on',
    created_by: 'Created By',
    updated_on: 'Updated On',
    updated_by: 'Updated By',
    owner: 'Agent',
    subject: 'Case Name',
    case_number: 'Case Number',
    due_date: 'Due_Date',
    incoming_fullname: 'Incoming Contact',
    incoming_phone: 'Incoming Phone',
    incoming_email: 'Incoming Email',
    source: 'Source',
    status: 'Status',
    closed_date: 'Closed Date',
    closed_reason: 'Closed Reason',
    priority: 'Priority',
    primary_campaign_id: 'Related Campaign',
    primary_contact: 'Primary Contact',
    case_org: 'Primary Company',
    group: 'Group',
    type: 'Type',
    stage_type: 'Case Process',
    current_stage: 'Current Stage',
    description: 'Description',
    resolution: 'Resolution',
    product: 'Product',
    parent_case_id: 'Parent Case',
  },
  CASEDASHBOARD: {
    TITLE: 'Case Dashboard',
    UNSOLVED: 'Unsolved',
    OVERDUE: 'Overdue',
    DUE_TODAY: 'Due Today',
    CLOSED: 'Closed',
    OPEN: 'Open',
    ON_HOLD: 'On Hold',
    HIGH_PRIORITY: 'High Priority',
    AVERAGE_RESOLVED_TIME: 'Average Resolved Time',
    DAY: 'Days',
    HOUR: 'Hours',
    MIN: 'Mins',
    PRIORITY: 'Priority',
    SOURCE: 'Source',
    GROUP: 'Group',
    TYPE: 'Type',
    PROCESS: 'Process',
    LINE_CHART: 'Case Line Chart',
    RECEIVED: 'Received Cases',
    RESOLVED: 'Resolved Cases',
    CASE_RANKING: 'Cases Ranking',
    CASES: 'Cases',
    UP: 'Up',
    DOWN: 'Down',
    AGENT_STATUS: 'Agent Status',
    AGENT_TOTAL: 'Total Agent'
  },
  UPCHATDASHBOARD: {
    TITLE: 'UpChat Dashboard',
  },
  CAMPAIGNSTAUSLIST: {
    PROPOSED: 'Proposed',
    READY_TO_ACTIVATE: 'Ready to activate',
    ACTIVATED: 'Activated',
    COMPLETED: 'Completed',
    CANCELLED: 'Cancelled',
    SHELVED: 'Shelved',
    NOT_IN_USE: 'Not in use',
  },
  IMPORT_EXPORT: {
    TITLE: 'Import CSV',
    TITLE_2: 'Export Csv',
    IMPORT: 'Import',
    EXPORT: 'Export',
    PAGE: 'Page',
    DATATYPE: 'CSV Type',
    STAGE: 'Stage',
    DOWNLOAD: 'Download',
    TEMP: 'Template',
    DB_DATA: 'All Data',
    SELECT: 'Select file',
    NOTICE: 'Notice',
    DOWNLOAD_TEMP: 'Download Template',
    ERROR: 'This browser does not support the export function, it is recommended to use Chrome or Edge',
    CONTACT_LABEL: 'Notice\n1. If you fill in the ID field, the information will be updated\n2. When filling in the Owner field, please separate the names with spaces, such as: David Smith\n3. Company Name, Campaign field content If it does not exist, it will be created automatically\n4. If the custom field name is duplicated, or if it is the same as the existing field name, the data will be overwritten\n5. When scientific notation appears in the data content, please adjust the cell format in Excel , to avoid data storage errors\n6. When filling in the date, please input in the format yyyy-mm-dd',
    ORG_LABEL: 'Notice\n1. If the ID field is filled in, the data will be updated\n2. When filling in the Owner field, please separate the names with spaces, such as: David Smith\n3. When the content of the Campaign field does not exist , it will be created automatically\n4. If the name of the custom field is repeated, or the name of the existing field is the same, the data will be overwritten\n5. When scientific notation appears in the data content, please adjust the cell format in Excel to avoid data Storage error\n6. When filling in the date, please input in the format yyyy-mm-dd',
    OPPTY_LABEL: 'Notice\n1. If the ID field is filled in, the information will be updated\n2. When filling in the Owner, Oppty Contact, Primary Contact fields, please separate the names with spaces, such as: David Smith\n3. Oppty If the content of Org, Oppty Contact, Primary Contact, Campaign field does not exist, it will be created automatically\n4. If the name of the custom field is duplicated, or the name of the existing field is the same, the data will be overwritten\n5. The content of the data will appear When using scientific notation, please adjust the cell format in Excel to avoid data storage errors\n6. When filling in the date, please input it in yyyy-mm-dd format\n7. Do not change the Stage Type, and confirm that the Current Stage is filled in correctly',
    CASE_LABEL: 'Notice\n1. If the ID field is filled in, the information will be updated\n2. When filling in the Owner and Primary Contact fields, please separate the names with spaces, such as: David Smith\n3. Primary Contact, Case If the content of the Org, Campaign, Group, Type fields does not exist, it will be created automatically\n4. If the custom field name is duplicated, or the name of the existing field is the same, the data will be overwritten\n5. The scientific notation appears in the data content Please adjust the cell format in Excel to avoid data storage errors\n6. When filling in the date, please input it in yyyy-mm-dd format\n7. Do not change the Stage Type, and confirm that the Current Stage is filled in correctly\n8. If the Case Number field is not filled in, it will be automatically created according to the autonumber setting',
    KA_LABEL: 'Notice\n1. If the ID field is filled in, the information will be updated\n2. When filling in the Owner field, please separate the names with spaces, such as: David Smith\n3. When the subject field does not exist , it will be created automatically\n4. When scientific notation appears in the data content, please adjust the cell format in Excel to avoid data storage errors\n5. Please fill in the Content field in HTML format\n6. If the Article Number field is not filled in, it will be automatically created according to the autonumber setting',
    PRODUCT_LABEL: 'Notice\n1. If the ID field is filled in, the information will be updated\n2. When filling in the Owner field, please separate the names with spaces, such as: David Smith\n3. When the Category、Series field does not exist , it will be created automatically\n4. When scientific notation appears in the data content, please adjust the cell format in Excel to avoid data storage errors\n5. When filling in the date, please input in the format yyyy-mm-dd',
    ORDER_LABEL: 'Notice\n1. If the ID field is filled in, the data will be updated\n2. When filling in the Owner and Contact fields, please separate the names with spaces, such as: Chen Zhenkai\n3. If the content of the Organization field does not exist, it will be automatically created\n4. When scientific notation appears in the data content, please adjust the cell format in Excel to avoid data storage errors\n5. When filling in the date, please enter it in the yyyy-mm-dd format',
    LICENSE_LABEL: 'Notice\n1. If the ID field is filled in, the data will be updated\n2. When filling in the Owner, Contact, Contact2, and Contact3 fields, please separate the names with spaces, such as: Chen Zhenkai\n3. If the Contact, Contact2, Contact3, Organization, and Product fields do not exist, they will be automatically created\n4. When scientific notation appears in the data content, please adjust the storage format in Excel. format to avoid data storage errors\n5. When filling in the date, please enter it in the yyyy-mm-dd format',
    SERVICE_LABEL: 'Notice\n1. If the ID field is filled in, the data will be updated\n2. When filling in the Owner, Contact, Contact2, and Contact3 fields, please separate the names with spaces, such as: Chen Zhenkai\n3. If the Contact, Contact2, Contact3, Organization, and Product fields do not exist, they will be automatically created\n4. When scientific notation appears in the data content, please adjust the cell format in Excel to avoid Data storage error\n5. When filling in the date, please enter it in the format of yyyy-mm-dd',
    FLEXFIELD_LABEL: 'Note\n1. If the ID field is filled in, the data will be updated\n2. Please confirm that the filled content conforms to the field format\n3. When scientific notation appears in the data content, please adjust the cell format in Excel to avoid data storage errors\n4. When filling in the date, please enter it in the yyyy-mm-dd format',
    COPY: 'Copy Message',
    ERROR_2: 'Please confirm the content of the imported file, or use the template file',
    ERROR_3: 'System is still processing data importation in background, Please wait and refresh page to check if data is imported sucessfully.',
    COPY_2: 'Copied',
    SEARCH: 'Search Words',
    ING: 'Processing',
    OPPTY_PRODUCT: 'Export Opportunity Products',
    PROGRESS: 'Current Progress : ',
    STILL_RUN: 'The import operation is in progress, do you want to check the progress in "Import/Upload Records"?',
  },
  UPCHAT: {
    TITLE: 'Message Log',
    SENDER: 'Sender : ',
    SENDER_B: 'Sender : Robot',
    ROBOT: 'B',
    NO_MESSAGE: 'No Message Log',
    SHOW: 'Show Messages',
    CHANNEL: 'Channel',
    BLANK: 'Please click conversation to show contact information',
    NO_AGENT: 'No agent assigned',
    SYNC: 'Are you sure you want to sync this contact?？',
    CIC: 'UpDay CIC',
  },
  DOCUMENT: {
    TITLE: 'Document',
    NO_DOC: 'No Document',
    NAME: 'Name',
    DESCRIPTION: "Description",
    CREATE: 'Created on',
    UPDATE: 'Updated on',
    ADD: 'Add Document',
    EDIT: 'Edit Document',
    DEL: 'Delete Document',
    NEW_FILE: 'Select New File',
    MESSAGE_DEL: 'Are you sure you want to delete this document?',
    MESSAGE_DEL_2: 'Are you sure you want to delete those documents?'
  },
  END_CUSTOMER: {
    TITLE: 'End Customer',
    ADD: 'Add data',
    EDIT: 'Edit data',
    NO_DATA: 'No data',
    DEL: 'Are you sure you want to delete this end customer?',
    NAME: 'End Customer Name',
  },
  BULK_EDIT: {
    TITLE: 'BulK Edit',
    CHANGE_STAGE: 'Change process',
    MESSAGE: 'Are you sure you want to update the following cases?',
    MESSAGE_CONTACT: 'Are you sure you want to update the following contacts?',
    MESSAGE_OPPTY: 'Are you sure you want to update the following opportunities?',
    MESSAGE_ORG: 'Are you sure you want to update the following organizations?',
    MESSAGE_DATA: 'Are you sure you want to update the ',
    MESSAGE_DATA_2: ' selected data?',
    MESSAGE_EMPTY: 'Please select the data to update',
    ERROR_CASE: 'The following cases have been closed. If you need to edit in batches, please set the "Closed Reason" as "Remove existing value".',
    ERROR_DEAL: 'The following business opportunities have been closed. If you need to edit them in batches, please update the "Closed Reason" and choose to reopen the business opportunity.',
  },
  BULK_EDIT_LIST: {
    0: 'Keep existing value',
    1: 'Replace existing value',
    2: 'Remove existing value',
  },
  INBOX: {
    SEND: 'Send',
    TITLE: 'Inbox',
    UNREAD: 'Unread',
    ALL: 'All',
    POST: 'Post',
    ALERT: 'Alert',
    FOCUS: 'Focus',
    NWE_POST: 'Write a Post',
    SUBSCRIBE: 'Subscribe',
    UNSUBSCRIBE: 'Unsubscribe',
    READ_MORE: 'Read More',
    READ_LESS: 'Read Less',
    DELETE: 'Are you sure you want to delete this post?',
    DELETE_ALERT: "Are you sure you want to delete this alert?",
    CONTENT_EMPTY: "Content Blank!",
    CONTENT_NOT_EMPTY: "If you discard now, you'll lose the content. You really want to discard?",
    FILE_LIMIT: "The total file attachments size can't more than 20MB",
    ALL_READ: "Mark All Read",
    ALL_DELETE: "Delete All Post",
    ALL_DELETE_CHECK: "Are you sure you want to delete all post which you are owner?",
    ALL_DELETE_ALERT: "Delete All Alert",
    ALL_DELETE_ALERT_CHECK: "Are you sure you want to delete all alert？",
    ERROR_POST: 'This post may be deleted. Please refresh Inbox content.',
    NO_NOTIFICATION: 'No new notifications, for now.  Go ahead and take a break!',
    ALL_HAVE_READ: 'Congratulations, all notifications have been read!',
  },
  FOLLOW: {
    CONTACT: "Follow or unfollow the selected contacts",
    ORG: "Follow or unfollow selected companies",
    CASE: "Follow or unfollow selected cases",
    OPPTY: "Follow or unfollow the selected opportunities",
    FOLLOW: 'Follow',
  },
  UPLOADSTATUS: {
    METHOD: 'Method',
    TYPE: 'Type',
    CREATE_TIME: "Created On",
    UPDATED_TIME: "updated On",
    FILE_NAME: "File Name",
    TOTAL: "Total",
    SUCCESS: "Success",
    FAIL: "Fail",
    STATUS: "Status",
    COMMENT: "Records",
    UPLOAD: 'Upload',
    IMPORT: 'Import',
    PROCESSING: "Processing",
    COMPLETE: "Complete",
    EMBEDDING: "Analyzing",
    SHOW: 'Show Records',
    NO_RECORD: 'No Records',
    MESSAGE_DELETE: 'Are you sure you want to delete the records?'
  },
  AL_MAIL: {
    TITLE: 'AI Writing Assistant',
    GENERATE: "AI Generate",
    SETTING: "AI Generation Settings",
    SEND_ALL: "Send All",
    TONE: "Tone",
    LENGTH: "Length",
    LANGUAGE: "Language",
    TIP: "Tip",
    SIGN: "Signature",
    REMAKE: "Regenerate",
    REMAKEING: "Regenerating...",
    NO_AMIL: "No AI Message",
    SENDING: "Sending...",
    FOLLOWUP: "Follow Up",
    SUMMARY: "Summary",
    CUSTOM: "Custom Type",
    TONE_1: "Professional",
    TONE_2: "Relax",
    TONE_3: "Stimulation",
    TONE_4: "Interesting",
    TONE_5: "Enthusiasm",
    LEN_1: "Short",
    LEN_2: "Medium",
    LEN_3: "Detailed",
    STATUS_1: "No message",
    STATUS_2: "Generated",
    STATUS_3: "Saved",
    STATUS_4: "Unsaved",
    STATUS_5: "Fail",
    CHANGE_ERROR: "Changing the channel or segment will delete the generated messages.",
    UNDO: "Undo",
    REMAKE_ALL: "Are you sure you want to delete existing data and generate messages with current settings?",
    SEND_CHECK: "Are you sure you want to send all messages?<br>Existing messages, settings will be deleted after completion.",
    MAKE_MSG: "The message is being generated, please wait patiently.<br>Click Update to confirm the current progress.",
    SMS_VENDOR: "Please set the SMS service provider to 'MITAKE'. If this service is not enabled, please contact the UpDay service team.",
    NO_CONTACT: "No contact available yet"
  },
  SERVICE_PRODUCT_LINE: {
    ORDER_STATUS: 'Order Status',
    OWNER: 'Owner',
    REMAIN_DAYS: 'Remain Days',
    END_ACCOUNT_NAME: 'End Customer Name',
    CONTACT: 'Contact',
    TYPE: 'Type',
    PROJECT_NAME: 'Support Package/Project Name',
    SLA: 'SLA',
    SERVICE_CONTENT: 'Service content',
    SERVICE_PLAN: 'Service plan',
    SERVICE_VENDOR: 'Service Vendor',
    START_DATE: 'Start Date',
    END_DATE: 'Acceptance/End Date',
    ORDER_NUMBER: 'Order Number',
    STATUS: 'Status',
    NOTE: 'Note',
    SO: 'SO',
    SO_LINE: 'SO Line',
    PO: 'PO',
    PROJECT_CODE: 'Project Code',
    RELATED_OPPTY: 'Related Opportunity',
    TECH: 'Technican',
    TECH_COST: 'Technican Cost',
    INVOIVE_MONTH: 'Invoice Month',
    INVOICE_PRICE: 'Invoice Amount',
    ESTMATED_G_P: 'Estimated Gross Profit',
    POFIT: 'Profit (%)',
    ORGANIZATION: 'Company',
  },
  LICENSE_PRODUCT_LINE: {
    PRODUCT_NAME: "Product Name",
    ORDER_STATUS: 'Order Status',
    OWNER: 'Owner',
    REMAIN_DAYS: 'Remain Days',
    END_ACCOUNT_NAME: 'End Customer Name',
    CONTACT: 'Contact Person',
    TYPE: 'Type',
    PRODUCTCODE: 'Project Number',
    BILLING_F: 'Billing Frequency',
    START_DATE: 'Start Date',
    END_DATE: 'End Date',
    ORDER_NUMBER: 'Order Number',
    STATUS: 'Status',
    NOTE: 'Note',
    SO: 'SO',
    SO_LINE: 'SO Line',
    PO: 'PO',
    PROJECT_CODE: 'Project Code',
    RELATED_OPPTY: 'Related Opportunity',
    TECH: 'Technican',
    TECH_COST: 'Technican Cost',
    INVOIVE_MONTH: 'Invoice Month',
    INVOICE_PRICE: 'Invoice Amount',
    ESTMATED_G_P: 'Estimated Gross Profit',
    POFIT: 'Profit (%)',
    SUBCRIPTION_NUMBER: 'Subcription Number',
    AGREEMENT_NUMBER: 'Agreement Number',
    CONTRACT_LEVEL: 'Contract Level',
    CONTRACT_NUMBER: 'Contract Number',
    PA_NUMBER: 'Pa Number',
    OKS_NUMBER: 'OKS Number',
    CSI_NUMBER: 'CSI Number',
    RENEW_ID: 'OCI Renew ID',
    INSTANCE_NUMBER: 'Instance Number',
    ORGANIZATION: 'Company',
  },
  PRODUCT_LINE_ITEM_LIST: {
    1: "All",
    2: "Temporary storage",
    3: "Under review",
    4: "Approved",
    5: "Return",
    6: "Activating",
    7: "Activation pending patch",
    8: "Additional documents pending review",
    9: "Contract has been renewed",
    10: "No renewal",
    11: "Disable",
    12: "Transfer",
    13: "Annual contract and annual payment",
    14: "Annual contract and monthly payment",
    15: "Monthly agreement and monthly payment",
    16: "Disposable",
    17: "Monthly payment",
    18: "No bill",
    19: "Trial",
    20: "Project type",
    21: 'Number of cases by service',
    22: 'Based on service hours',
    23: '7*24 maintenance service',
    24: 'All inclusive',
    25: 'Project type',
    26: 'None',
    27: 'Self-maintenance',
    28: 'Outsourcing manufacturer',
    29: 'Azure usage % system',
    30: 'Wiadvance OP',
    31: 'Wiadvance Technology',
    32: 'Outsourcing manufacturer',
    33: 'New purchase',
    34: 'Additional purchase',
    35: 'Renewal',
    36: 'Upgrade',
    37: 'Deactivate',
    38: 'Transfer',
    39: 'Exchange',
    40: 'Trial',
    41: 'Permanent License',
  },
  OPPTY_SELECT_FIELDS_LIST: {
    1: "Establish",
    2: "Tracking",
    3: "Dealed",
    4: "Untransacted",
    5: "Follow-up",

    6: "High Technology",
    7: "Manufacturing",
    8: "Information/Software",
    9: "Government",
    10: "Education (school)",
    11: "Other public entities",
    12: "hospital",
    13: "Medical related",
    14: "Construction",
    15: "Retail/Wholesale",
    16: "Hotel/B&B",
    17: "Advisory/Investment",
    18: "Finance/Accounting",
    19: "Insurance",
    20: "NPO/Foundation Legal Person",
    21: 'Service Industry',
    35: 'Default',

    22: 'Web Leads',
    23: 'Customer service by phone',
    24: 'official website',
    25: 'Customer service mailbox',
    26: 'Activity',
    27: 'Business opportunity',
    28: 'Other',

    29: '0%(to be contacted)',
    30: '20%(negotiation)',
    31: '40%(Sales)',
    32: '60%(negotiation)',
    33: '80%(deal)',
    34: '100%(profit)', // 35已用在21下
  },
  // GPT----------------------------------------------------------------
  GPT_MENU: {
    DASHBOARD: "Dashboard",
    KNOWLEDGE: "Knowledge",
    CHATBOT: "AI Bot",
    CHATBOTS: "AI Bots",
    CHAT_HISTORY: "Chat History",
    USER_MANAGEMENT: "User Management",
    GROUP_MANAGEMENT: "Group Management",
    DATA_CENTER: "Data Center",
    USAGE_ANALYSIS: "Usage Analysis",
    UPLOADSTATUS: 'Upload Record',
    BACKTO: "Back to ",
    MEETINGRECAP: "Meeting Recap",
    AINOTEBOOK: "AI Notebook",
    PORTAL: "Portal",
    USER_ANALYSIS: "Conversation Insight",
    LOGIN_PAGE_SETTING: "Login Page Settings",
    INTEGRATIONS: "Integrations",
  },
  // INTEGRATION groups: TITLE/SUBTITLE (page; nav item is GPT_MENU.INTEGRATIONS), TAB (tabs), HOW_TO (how to integrate), KEY (API key create/list/delete), ALLOWED (allowed APIs dialog), API (name/description per api_code), REF (API reference: fields, errors), LOG (call logs), TOAST, COMMON
  INTEGRATION: {
    TITLE: "Integrations",
    SUBTITLE: "Manage the API keys that third-party systems use to call UpGPT integration APIs.",
    TAB: {
      API_KEYS: "API Keys",
      CALL_LOGS: "Call Logs",
      HOW_TO: "How to Integrate",
    },
    HOW_TO: {
      STEP1_TITLE: "Create an API key",
      STEP1_DESC: "Create an API key on the API Keys tab and save the full key right away. Once you close the window, the full key won't be shown again.",
      STEP2_TITLE: "Choose which APIs the key can call",
      STEP2_DESC: "On the API key list, click \"Set Allowed APIs\" and select the integration APIs this key can call. A key with no APIs selected can't call any integration API.",
      STEP3_TITLE: "Call the API with the key in the request header",
      STEP3_DESC: "When calling an integration API, include the API key in the request header:",
      STEP3_NOTE: "You can find each integration API's URL, request body, and response format under \"View API Reference\" in \"Set Allowed APIs\".",
      GO_TO_API_KEYS: "Go to API Keys",
      HEADER_NAME: "X-API-Key",
      API_KEY_PLACEHOLDER: "<YOUR_API_KEY>",
    },
    KEY: {
      CREATE: "Create API Key",
      NAME: "Name",
      NAME_HINT: "Identifies what this key is for, such as the name of the integrated system.",
      NAME_PLACEHOLDER: "e.g. Website support bot",
      NAME_REQUIRED: "Name is required.",
      NAME_DUPLICATE: "This name is already in use.",
      CREATED_TITLE: "API Key Created",
      CREATED_FULL_KEY: "Full API key for \"{name}\":",
      CREATED_WARNING: "You won't be able to see this API key again after closing this window. Copy it now and store it securely.",
      CREATED_LOST_HINT: "If you lose it, you can only delete it and create a new one.",
      CREATED_NEXT_STEP: "This API key can't call any APIs yet. Next, complete \"Set Allowed APIs\".",
      SAVED_CLOSE: "I've saved it, close",
      COL_KEY: "Key",
      COL_ALLOWED_APIS: "Allowed APIs",
      COL_STATUS: "Status",
      COL_CREATED: "Created",
      COL_ACTIONS: "Actions",
      ENABLED: "Enabled",
      DISABLED: "Disabled",
      ENABLE: "Enable",
      DISABLE: "Disable",
      DELETE: "Delete",
      SET_ALLOWED_APIS: "Set Allowed APIs",
      VIEW_CALL_LOGS: "View Call Logs",
      DELETE_TITLE: "Delete API key \"{name}\"?",
      DELETE_DESC: "All calls using this key will fail, and its call logs will be deleted. This cannot be undone.",
      EMPTY: "No API keys yet.",
      EMPTY_DESC: "Once you create an API key, third-party systems can call UpGPT integration APIs by including it in the request header.",
    },
    ALLOWED: {
      DESCRIPTION: "Select the integration APIs this key can call. Changes take effect as soon as you save. You can leave all unselected, in which case this key can't call any integration API.",
      VIEW_API_REFERENCE: "View API Reference",
      USAGE_TITLE: "How to Call — {name}",
    },
    API: {
      simple_agent_ask: {
        NAME: "Ask a Simple Agent",
        DESCRIPTION: "Specify a Simple Agent and ask a question to get the full answer and its sources in one response (single-turn; earlier conversations are not continued).",
      },
    },
    REF: {
      BACK: "Back to API list",
      METHOD_AND_URL: "Method & URL",
      METHOD: "Method",
      HEADERS: "Headers",
      REQUEST_BODY: "Request Body",
      RESPONSE: "Response",
      SUCCESS_RESPONSE: "Success Response (200)",
      ERRORS: "Errors",
      REQUEST_BODY_EXAMPLE: "Request body example",
      CURL_EXAMPLE: "cURL example",
      RESPONSE_EXAMPLE: "Response example",
      ERROR_EXAMPLE: "Error response example",
      ERROR_CODE: "Error Code",
      REASON: "Reason",
      HTTP_STATUS: "HTTP Status",
      AVAILABLE_AGENTS: "Available Simple Agents",
      AGENT_ID: "Agent ID",
      AGENT_NAME: "Agent Name",
      NO_AGENTS: "No public Simple Agents in this tenant yet.",
      PLACEHOLDER_NOTE: "The API key in the examples is a placeholder. Replace it with the full key you saved.",
      HEADER_DESC: "Your API key. Required on every call.",
      ERROR_FORMAT: "Every error response is JSON with a code and a message. The code is always lowercase.",
      COL_FIELD: "Field",
      COL_TYPE: "Type",
      COL_REQUIRED: "Required",
      COL_DESCRIPTION: "Description",
      COL_VALUE: "Value",
      YES: "Yes",
      NO: "No",
      FIELD: {
        agent_id: "ID of the Simple Agent to ask. Pick one from \"Available Simple Agents\" below.",
        question: "The question to ask, up to 1000 characters. A value with only whitespace is treated as empty.",
        answer: "The agent's complete answer. Citations are marked as [1], [2], and so on, matching the index in citations.",
        citations: "Sources cited in the answer, ordered by index. An empty array if nothing is cited.",
        index: "Citation number, matching the [n] in answer.",
        source: "Source type: knowledge (knowledge base document) or web (web search).",
        title: "File name for a knowledge base document; page title for a web search result.",
        section: "Section title of a knowledge base document; null if there is none.",
        pages: "Page numbers cited from a knowledge base document; an empty array if there are none or the source is web.",
        url: "Only web search results have a URL; always null for knowledge base documents.",
      },
      ERROR_REASON: {
        missing_api_key: "The X-API-Key header is missing from the request.",
        invalid_api_key: "The API key does not exist or has been deleted.",
        api_key_disabled: "The API key is disabled.",
        api_not_allowed: "The API key is not allowed to call this API. Select it in \"Set Allowed APIs\".",
        invalid_request: "A required field is missing or malformed. The message names the field with the problem.",
        agent_not_found: "The specified agent does not exist, was deleted, is not a public Simple Agent, or is disabled or unpublished.",
        internal_error: "An error occurred while processing the request.",
        agent_timeout: "The agent did not respond within the maximum wait time (30 minutes).",
      },
    },
    LOG: {
      COL_TIME: "Time",
      COL_API: "API",
      COL_HTTP_STATUS: "HTTP Status",
      COL_KEY: "API Key",
      SUCCESS: "Success",
      FAILED: "Failed",
      EMPTY: "No call logs yet.",
      EMPTY_FILTERED: "No call logs match the filters.",
      FILTER_RESULT: "Result",
      FILTER_FROM: "Called From",
      FILTER_TO: "Called To",
      FILTER_ALL: "All",
      FILTER_CLEAR: "Clear filters",
      DETAIL_TITLE: "Call Log Details",
      TOTAL: "{count} records in total",
    },
    TOAST: {
      ENABLED: "Enabled \"{name}\".",
      DISABLED: "Disabled \"{name}\". Calls using this key will be rejected.",
      DELETED: "API key deleted.",
      ALLOWED_SAVED: "Allowed APIs saved.",
      ERROR: "Something went wrong. Please try again later.",
    },
    COMMON: {
      COPY: "Copy",
      COPIED: "Copied",
      CANCEL: "Cancel",
      SAVE: "Save",
    },
  },
  KB_AND_BOT_PERMISSION_SETTING: {
    PERMISSION_SETTING: "Permission Setting",
    MANAGER: "Manager",
    VIEWER: "Viewer",
    ONLY_SYSTEM_ADMIN: "Only system administrators",
    CUSTOM_SETTING: "Customize",
    ALL_USER: "All users",
    SEARCH_USER: "Search users",
    SEARCH_GROUP: "Search groups",
    CLEAR_SEARCH: "Clear search",
    SELECT_ALL_RESULTS: "Select all results",
    NO_MATCH_USER: "No users match \"{q}\"",
    NO_MATCH_GROUP: "No groups match \"{q}\"",
  },
  GPT_KNOWLEDGE: {
    TITLE: "Knowledges",
    UPLOADER: "Uploaded by",
    UPLOAD_TIME: "Upload time",
    FILE_STATUS: "Status",
    STATUS_COMPLETE: "Uploaded",
    STATUS_PROCESSING: "Processing",
    PROCESS_METHOD: "Processing method",
    NAME: "Knowledge base name",
    DOCS: "Documents",
    CREATED_ON: "Created on",
    UPDATED_ON: "Last updated",
    UPDATED_BY: "Updated by",
    ROBOTS: "Robot",
    BACKTO: "Back to ",
    LAST_UPDATED: "Last Updated",
    OPEN_LIB: "On",
    CLOSE_LIB: "Off",
    ONOFF: "Turn On/Off knowledge",
    LINKBOT: "Link AI Bot",
    NO_LINKBOT: "Not yet linked",
    CLEAR: "Clear",
    CLEAR_ALL: "Clear Knowledge",
    DELETE_SIMPLE: 'Delete',
    DELETE: 'Delete Knowledge',
    DEL_MSG: "Are you sure you want to delete this knowledge?",
    CLEAR_MSG: "Are you sure you want to clear this knowledge?",
    SETTING: "Knowledge Setting",
    UPLOAD: "Knowledge File Upload",
    ERROR: "This knowledge name already exists",
    PUBLIC: "Global knowledge base",
    ISPUBLIC: "Shared",
    ADD_COLUMN: "Add Field",
    EDIT_COLUMN: "Edit Field",
    ADD: "Add",
    EDIT: "Edit",
    CLEAR_ERROR: "The knowledge files are cleared, please refresh the screen later.",
    DELETE_ERROR: "The knowledge will be deleted after it' files cleared. Please refresh the screen later.",
    SYSTEM_NAME_ERROR: "Same System Name in other knowledge，please rewrite the name",
    SINGAL_DELETE: "Are you sure you want to delete this file?",
    MULTIPLE_DELETE: "Delete Selected",
    MULTIPLE_DELETE_CHECK: "Are you sure you want to delete the {count} selected files?",
    MULTIPLE_DELETE_PROGRESS: "Deleted {done} / {total}",
    MULTIPLE_DELETE_RESULT: "Deletion finished: {success} succeeded, {fail} failed. Failed files may still be processing; please refresh later.",
    DELETEING: "The file is being deleted, please refresh this page later.",
    IMAGE_SELECTION: "Image processing",
    DELETING: "The file is being deleted, please refresh this page later.",
    TIP_1: "The following files will be used to build a knowledge base, and the AI ​​robot will answer questions based on the content of the knowledge base.",
    TIP_2: "Upload the Q&A file here. The file must be in csv format and the content must be UTF-8 encoded.",
    TIP_3: "Upload the compressed file here. The file must be in zip format. Please compress the file directly without putting it in another folder.",
    TIP_4: "Upload txt, pdf, docx, pptx files here. If you need to upload csv files, please go to the Q&A information to upload.",
    TIP_4_IDP: "Upload pdf, docx, pptx, xlsx files here. If you need to upload csv files, please go to the Q&A information to upload.",
    TIP_5: "Add websites that need to be analyzed here. You can add up to 5 websites, and the depth is up to 2. After the addition is completed, please click 'Start Analysis'.",
    TIP_6: "Upload images in JPG, JPEG, PNG format here.",
    TIP_7: " Records are retained for 21 days.",
    TIP_8: "Upload pdf, docx, pptx, jpg, jpeg, png formats here.",
    SYSTEM_NAME_TIP: "Help AI to search. English only and unique, e.g. HR, Product, Safety, etc",
    SYSTEM_NAME_LABEL: "System Name",
    DESCRIPTION_TIP: "The description helps AI understand what this knowledge is about for searching",
    CATEGORY: "Category",
    PROCESSING_FILE: "Processing File",
    KNOWLEDGE_FOLDER: "Knowledge Folder",
    KNOWLEDGE: "Knowledges",
    UPDATE_FOLDER_PERMISSION: "Do you want to apply this permission to all subfolders and knowledge bases? This operation will overwrite the permissions of subfolders and knowledge bases.",
    MOVE_SAME_LOCATION: "The selected location is the same as the current one. Please choose another folder.",
    MOVE_NO_PERMISSION: "You don't have manage permission on this knowledge library or the target folder.",
    MOVE_FAIL: "Failed to change location. Please try again later.",
  },
  ADD_KNOWLEDGE: {
    TITLE: 'New Knowledge',
    KB: 'Knowledge',
    FOLDER: 'Folder',
    CATEGORY: "Category",
    CATEGORY_PH: "Select or create category",
    CATEGORY_HTNT: "Category of Knowledge, e.g. HR, Product, IT, etc",
    NAME: 'Name',
    NAME_PH: "Name of knowledge",
    NAME_HINT: "Must be Unique, and can't be modified after created.",
    SYSTEM_NAME_HINT: "Must be English and Unique for system identification.",
    DESCRIPTION: "Description",
    DESCRIPTION_PH: "The character limit is 100 characters",
    DESCRIPTION_HINT: "This description is required and helps the AI understand and retrieve relevant information.",
  },
  KNOWLEDGE_FOLDER: {
    library: 'Knowledge Base',
    folder: 'Folder',
  },
  ADD_KNOWLEDGE_FOLDER: {
    TITLE: 'Add Knowledge',
    EDIT_TITLE: 'Edit Knowledge',
    NAME: 'Name',
    PATH: 'Parent',
    PERMISSION_SETTING: 'Permission settings',
    PERMISSION_SETTING_DEFAULT: '(Default permission settings are for the parent layer)',
    ONLY_SYSTEM_ADMIN: 'Only system administrators',
    ONLY_SYSTEM_VIEWER: 'All users',
    CUSTOM_SETTING: 'Custom',
    DELETE_MSG: 'It will delete all the subfolders and knowledge, are you sure?',
    ERROR1: 'The currently selected path is the same as before; the folder location will not change. Please select again.',
    ERROR_2: 'The parent folder cannot be set as its own subfolder.',
    ERROR_3: 'This folder name already exists, please enter again.'
  },
  FOLDER_LOCATION_PICKER: {
    TITLE: "Select Folder",
    CURRENT: "Current selection",
    NOT_SELECTED: "Not selected",
    CREATE_FOLDER: "Create Folder",
    PLACEHOLDER: "Select a folder...",
    DRAFT_HINT: "New",
    NEW_FOLDER_DEFAULT: "New folder",
  },
  GPT_UPLOADIMG: {
    DESCRIBE_IMG: 'Image Understanding',
    CUSTOMER_ATTRIBUTE: 'Custom Attributes',
    IMG_SEARCH: 'Image Search',
    IDP: "Intelligent Document Processing",
    TIP_1: "Upload image here and configure how you would like the AI to process here.",
    TIP_2: "AI will extract the attributes from the image and save into a table. It is very useful if you want AI to anwer questions like 'the top 3 expensive items in Asia. Please contact us to activate this function'.",
    TIP_3: "AI will describe the image in detail, and users can ask questions and search answers based on it.",
    FILEUPLOADMESSAGE: 'Only JPG, JPEG and PNG files are accepted',
    START_ANALYSIS: 'Start Analysis',
    IMAGE_STATUS: 'Status',
    IMAGE_TIP_1: "Image processing is available in enterprise edition. Please contact us at support@upday.ai to enable the feature.",
    IMAGE_TIP_2: "Intelligent Document Processing is available in enterprise edition. Please contact us at support@upday.ai to enable the feature.",
    IMAGE_TIP_3: "Image processing and Intelligent Document Processing are available in enterprise edition. Please contact us at support@upday.ai to enable the feature.",
    IMAGE_TIP: "Image processing is available in enterprise edition. Please contact us at support@upday.ai to enable the feature.",
    CLOUD_TIP: "Cloud storage processing is available in enterprise edition. Please contact us at support@upday.ai to enable the feature.",
  },
  GPT_CLOUD: {
    CONNECT_CLOUD: 'Connect Cloud',
    CONNECT_ACCOUNT: 'Connect Account',
    RESET: 'Reset',
    SAVE: 'Save',
    DELETE_CHECK: 'Are you sure you want to delete this cloud account setting?\nOnce confirmed, all linked files will be deleted from the knowledge base',
    CLOUDSYNC_ERROR: 'Deletion failed, please try again',
    MY_DRIVE: 'My Drive',
    SHARE_WITH_ME: 'Shared with Me',
    SHAREPOINT: 'Sharepoint',
    ONEDRIVE_LOCKED: 'The OneDrive for this account is currently locked and cannot be accessed. Please contact your Microsoft 365 administrator to unlock it.',
    ONEDRIVE_ACCESS_FAILED: 'Failed to access OneDrive. Please try again later or contact your administrator.',
    EXCEED_MAX_SIZE: 'The total size of uploaded files exceeds',
    MAX_FILES: "Too many files, only the first 2000 entries are displayed."
  },
  GPT_ANALYSIS: {
    NAME: "Data Analysis",
    USED_TOKEN: "Consumed Token",
    MSG_TOKEN: "Average Token consumption per message",
    MSG_Q: "Message Quantity",
    MSG_PER_Q: "Average spent Token",
    ACU: " accumulated results consumed Token",
    THIS_PERIOD: 'This period',
    PREVIOUS: 'Last period',
    TABLE_HEADER_1: "Intelligent Robot",
    TABLE_HEADER_2: "Channel",
    TABLE_HEADER_3: "Prompt Tokens",
    TABLE_HEADER_4: "Completion Tokens",
    TABLE_HEADER_5: "Fees",
    TABLE_HEADER_6: "Time",
    TABLE_HEADER_7: "Knowledge",
    TABLE_HEADER_8: "Use type",
    TABLE_HEADER_9: "Tenant",
    TABLE_HEADER_10: "Subscription Expiration",
    STORAGE_USAGE: 'Storage Usage',
    IMAGE_STORAGE_USAGE: 'Image Storage Usage',
    STORAGE_USAGE_TIP: "Total size of files linked in all knowledge bases",
    IMAGE_STORAGE_USAGE_TIP: "Total number of images linked in all knowledge bases",
    INTELLIGENT_DOCUMENT_USAGE_TIP: "Total Intelligent Document Processing usage",
    USED: 'used',
    PIECE: "images",
    PAGE: " pages",
    END_DATE: ' EXP:',
    REMAIN_AMOUNT: 'Remaining Amount',
    USING_AMOUNT: 'Amount used'
  },
  GPT_TREADANALYSIS_DRAWER: {
    THREAD: "Thread",
    FEEDBACK: "Helpful",
    HELPFUL: "Helpful",
    UNHELPFUL: "Unhelpful",
    ACCURACY: "Accuracy",
    RELEVANCE: "Relevance",
    REFERENCES: "References",
    ANSWER: "Answer",
  },
  GPT_USER_ANALYSIS: {
    ANSWER: 'Answers',
    HELPFUL: 'Helpful',
    UNHELPFUL: 'Unhelpful',
    RELEVANCY: 'Relevancy',
    RELEVANCY_H: 'High Relevance',
    RELEVANCY_L: 'Low Relevance',
    STATISTICS: "Statistics",
    RELATED: "Related",
    UNRELATED: "Unrelated",
    ACCURACY: "Accuracy",
    ACCURACY_H: "High Accuracy",
    ACCURACY_L: "Low Accuracy",
    ACCURATE: "Accurate",
    INACCURATE: "Inaccurate",
    DATE: "Date",
    CATEGORY: "Category",
    AVG_RELEVANCY: "Average Relevancy",
    AVG_ACCURACY: "Average Accuracy",
    TOTAL_ANSWER: "Total Answers",
    HELP_UNHELP: "Helpful",
    THIS_WEEK: "This Week",
    RECORDS: "records",
    ALL: "All",
    TODAY: "Today",
    THIS_MONTH: "This Month",
    DATE_RANGE: "Date Range",
    LAST_7_DAYS: "Last 7 Days",
    SELECT_DATE_RANGE_ERROR: "Please Choose a Date Range"
  },
  GPT_THREAD_ANALYSIS: {
    THREAD_ANALYSIS: "Thread Summary",
    DATE: "Date",
    THREAD_NAME: "Thread",
    ANSWER: 'Answer',
    HELPFUL: 'Feedback',
    ACCURACY: "Accuracy",
    RELEVANCY: "Relevancy",
    FILES: "Files",
    NO_FEEDBACK: "No Feedback"
  },
  GPT_IDP: {
    DOCUMENT_ANALYSIS: 'Document Processing',
    REMAIN_DOCUMENT_ANALYSIS: 'Remaining intelligent document processing pages',
    DOCUMENT_ANALYSIS_STORAGE_USAGE: 'Intelligent Document Processing Usage',
    TIP_1: 'Use advanced AI to analyze your documents. Please check your available quota in Usage Analysis page.',
  },
  GPT_AIBOTS: {
    TITLE: "AI Bots",
    AIASSISTANTNAME: 'AI Assistant Name',
    AIASSISTANTNAME_TIP1: 'To set your AI assistant\'s name',
    AIASSISTANTNAME_TIP2: 'For example: Ann',
    AIASSISTANTROLE: 'AI Assistant Role',
    AIASSISTANTROLE_TIP1: 'To set your AI assistant\'s role',
    AIASSISTANTROLE_TIP2: 'For example: customer service agent for UpDay, a CRM production designed by ART Solutions Limited',
    TOPIC: 'Topic',
    TOPIC_TIP1: 'Give AI assistant a topic to help it rephrase questions better',
    TOPIC_TIP2: 'For example: UpDay CRM',
    TOPICLIMIT: 'Topic Limit',
    TOPICLIMIT_TIP1: 'If topic goes off, AI assistant will redirect conversation back',
    TOPICLIMIT_TIP2: 'For example: technology',
    REPLY_LANGUAGE: 'Reply Language',
    REPLY_LANGUAGE_TIP: 'AI assistant will reply in language which you choosed',
    MODEL: 'AI Model',
    MEMORY_LENGTH: 'Chat Memory',
    RETURN_KNOWLEDGE: 'Get Knowledge',
    INBOX: "Inbox",
    HAS_LINKED_BOT: "This inbox is already connected to another robot.",
    NO_EXIST_BOT: "There is no UpChat robot yet, please contact UpGPT customer service to set it up.",
    VERBOSITY: "Verbosity",
    REASONING_EFFORT: "Reasoning Effort"
  },
  ADD_AIBOTS: {
    TITLE: 'New',
    NAME: 'Name',
    DESCRIPTION: 'Description',
    INBOX: "Inbox",
    KNOWLEDGE: "Knowledge",
    CONNECT_TO: "Connect to",
    MEMORY_LENGTH: 'Chat Memory',
    RETURN_KNOWLEDGE: 'Get Knowledge',
    RETURN_TONE: 'Response Tone',
    RETURN_LEN: 'Response Length',
    AI_DISCLAIMER: 'Allow AI disclaimer',
    CITATION: 'Allow citations',
    FILELINK: 'Return document link in reference',
    IMAGE_SEARCH: 'Allow image search',
    RETURN_IMAGE_QUANTITY: 'Number of images returned',
    RETURN_REPLY_WITH_IMAGE: 'Reply with Images',
    SHOW_ALL_IMAGE: "Show all related images",
    HIDE_ANSWER_WITHOUT_REFERENCE: "Hide answer if no reference",
    SHOW_PRIVATE_KNOWLEDGE: "Show private knowledge",
    WEB_SEARCH_TOGGLE: "Allow  web Search",
    ROLE: "Role",
    SCOPE: "Scope",
    TOPIC: "Topic",
    ONOFF: "Turn On/Off Robot",
    DETAIL: "AI Bot Detail",
    BRAIN_SIZE: "Brain Size",
    C_SETTING: "Character Setting",
    DEL_MSG: "Are you sure you want to delete this AI bot?",
    BEST_SIZE: "Best size: 120×30px",
    M_1: "Fine tunning the brain setting.",
    M_2: "AI bot will reply based on the knowledge base provided",
    M_3: "Remember more chat memory will have a more contextual slower reply.\nGet more knowledge will provide more useful context but slower reply.",
    M_4: "The AI bot will react and respond to users based on the character setting.",
    M_5: "Role will affect tune and attitude of response.",
    M_6: "AI bot only replies to users in the scope provided.",
    M_7: "Help the AI bot reply better with a context.",
    M_8: "The AI bot's self-proclaimed name.",
  },
  DETAIL_LEVEL: {
    "CONCISE": "Concise",
    "NORMAL": "Normal",
    "DETAILED": "Detailed"
  },
  TONE_LEVEL: {
    "PROFESSIONAL": "Professional",
    "FRIENDLY": "Friendly",
    "CASUAL": "Casual",
    "INSPIRING": "Inspiring",
    "PASSIONATE": "Passionate",
    "WARM": "Warm",
  },
  GPT_UPLOAD: {
    DEL_K: "Deleted Knowledge",
    AutoSync: "Cloud Auto Sync",
    ManualSync: "Cloud Manual Sync",
    AutoKnow: "Linked Knowledge Base"
  },
  GPT_USER: {
    T_1: "Personal Information",
    T_2: "Change Password",
  },
  GPT_CHAT_HISTORY: {
    CHANNEL: "Channel",
    C_USER_NAME: "User Name",
    LAST_CHAT_TIME: "Last Message Time",
    L_SELECT: "Please select a conversation from the left side",
    SEARCH: "Search messages",
  },
  GPT_MEETINGRECAPS: {
    TITLE: "Meeting Recaps",
    NAME: "Name",
    participants: "participants",
    OWNER: "Owner",
    TIME: "Time",
    DELETE: "Are you sure you want to delete this meeting recap?"
  },
  GPT_MEETINGRECAP: {
    TITLE: "Meeting Recap",
    NAME: "Meeting",
    MS: "Meeting Summary",
    OWNER: "Owner",
    MS_TIME: "Meeting Time",
    ANR: "AI Notebook Relationship",
    AN: "AI Notebook",
    OPPTY: "Opportunity",
    ANs: "AI Notes",
    TS: "Transcript",
    ANALYZE: "AI Analyze",
    SUGGEST_TASKS: "Suggested Tasks",
    CREATE_TASKS: "Create Tasks",
    VIEW_TASKS: "View Tasks",
    SUMMARY: "Generate summary",
    VALIDATE: "Please confirm the required fields and bind the opportunity.",
    NO_T: "No Transcript.",
    DELETED_MEETING_RECAP: "This meeting recap have been deleted, please refresh the page.",
    EXIST_SUMMARY_AND_TASK: "Meeting summary and suggest tasks have been generate, please refresh the page and check the content.",
    MAIL_SETTING: "Confirming Mail setting",
    MAIL_GENERATE: "AI mail is being generated",
    EMPTY_SUMMARY: "AI can't generate email with empty meeting summary.",
    EMPTY_CUSTOM_PROMPT: "AI can't generate custom mail with empty prompt.",
    EMPTY_SUMMARY_TASK: "AI can't generate tasks meeting summary.",
    TASK_CANT_FIND_ACTIVITY: "Related activity has been deleted, please create a new one.",
  },
  GPT_AINOTEBOOK: {
    TITLE: "AI Notebooks",
    LAST_UPDATED: "Last Updated",
    DESCRIPTION: 'Description',
    RECORD_TYPE: 'Record Type',
    DELETE: "Are you sure you want to delete this AI Notenbook?",
    DELETE_ERROR: "At least one AI notebook is required",
    DEFAULT: "System Default",
    CRM_TIP: "Select the CRM data that you want Ann to extract from meeting for you automatically.",
    AI_NOTE_TIP: "Define the data that you want Ann to extract from meeting for you automatically. ",
  },
  ADD_AINOTEBOOK: {
    TITLE: 'Add AINotebook',
    EDIT: 'Edit AINotebook',
    ADD: 'Add',
    COLUMN: 'Column',
    NAME: 'Name',
    DESCRIPTION: 'Description',
    DELETE_ERROR: "Are you sure you want to delete this field?",
    NAME_HINT: 'After the AINotebook is established, the name cannot be modified.',
    COLUMN_NAME_HINT: 'After the column name is established, the name cannot be modified.',
    LIMIT_HINT: 'Field description is limited to 50 words',
    LIMIT_COLUMNS: 'The number of columns has reached the limit.',
    CRM_SYSTEM_FIELD: 'CRM Field',
  },
  //Up Meeting
  UPMEETING: {
    LOGIN: "UpSide AI Assistant",
    ANN: "Ann",
    CHANGE_AN: "Changing AI Notebook will clear the recorded information.",
    NOTE_C: "Fields have been filled in.",
    MEETING_OVER: "Your meeting has ended. Click the link below to view the record:",
    L_D_TITLE: "Do you want to keep the last meeting you attended?",
    L_D_LAST: "Keep the meeting",
    L_D_NEW: "Start a new meeting",
    FINISH: "Finish",
    CAPTION_ERROR: "Please open Teams or Google Meetings first.",
    IMAGE_PREFIX: "AI analyzing questions...",
    QUERY_PREFIX: "AI keywords are being generated...",
    SEARCH_PREFIX: "AI information analysis...",
    IMAGE_ERROR: "Image analysis failed, please try again.",
    BACKEND_ERROR: "You do not have permission or the system settings are incorrect. Please contact the system administrator.",
    SHOT_BTN_TITLE: "AI Information Analysis",
    NO_QA: "Please click the AI icon or enter a keyword to query for answer.",
    Problem_Analysis: "Problem Analysis",
    Causes_Analysis: "Causes Analysis",
    Solutions: "Solutions",
    Actions: "Actions",
    References: "References",
    OutlookError: "There is no open email, or the settings do not match",
    VisionOn: 'Vision On',
    VisionOff: 'Vision Off',
    WAITING: "Reading and analyzing data, please wait a moment.",
  },
  // Order
  ORDER: {
    TITLE: 'Order',
    WIADVANCE_TITLE: 'Contract',
    NAME: 'Order Name',
    WIADVANCE_NAME: 'Contract Name',
    ENDACCOUNT: 'End Customer',
    CLIENT_NAME: 'Client Name',
    ORGANIZATION_NAME: 'Company Name',
    ENDACCOUNT_NAME: 'End Customer Name',
    CONTACT_NAME: 'Contact Name',
    SHIPPING_METHOD: 'Shipping Method',
    PAYMENT_TERM: 'Payment Term',
    SHIPPING_TERM: 'Shipping Term',
    BILLING_ADDRESS: 'Billing Address',
    SHIPPING_ADDRESS: 'Shipping Address',
    DESCRIPTION: 'Description',
    AMOUNT: 'Amount',
    ORDER_STATUS: 'Order Status',
    WIADVANCE_ORDER_STATUS: 'Contract Status',
    ORDER_SALES: 'Business',
    FROM_DATE: 'Time Expiration',
    TYPE: 'Type',
    BILLING_FREQUENCY: 'Billing Frequency',
    PRODUCT_CODE: 'Product Code',
    PROJECT_CODE: 'Project Code',
    PRODUCT_NAME: 'Product Name',
    QUANTITY: 'Quantity',
    START_DATE: 'Start Date',
    PURCHASE_ACTIVATION_DATE: 'Purchase/Start Date',
    ACCEPTANCE_COMPLETION_DATE: 'Acceptance/Due Date.',
    DUE_DATE: 'Due Date',
    ORDER_NUMBER: 'Order Number',
    STATUS: 'Status',
    NOTE: 'Note',
    PROJECT_NAME: 'Support Package / Project Name',
    MESSAGE_DEL_ORDER: 'Are you sure you want to delete this data?',
    SERVERS: 'Servers',
    SERVICE_CONTENT: 'Service Content',
    SERVICE_PLAN: 'Service Plan',
  },
  ADD_ORDER: {
    TITLE: 'Add Order',
    WIADVANCE_TITLE: 'Add Contact',
    NAME: 'Order Name',
    WIADVANCE_NAME: 'Contact Name',
    ORZ: 'Client',
    CONTACT: 'Contact',
    NO_CONTACT: 'Please input Contact name for search',
    NEW_CONTACT: 'Create a new contact',
    OLD_CONTACT: 'Select an existing contact',
    AMOUNT: 'Amount',
    SHIPPING_METHOD: 'Shipping Method',
    PAYMENT_TERM: 'Payment Term',
    SHIPPING_TERM: 'Shipping Term',
    BILLING_ADDRESS: 'Billing Address',
    SHIPPING_ADDRESS: 'Shipping Address',
    LAST_NAME: 'Last name',
    FIRST_NAME: 'First name',
    SERVICE_CONTENT: 'Service Content',
    SERVICE_PLAN: 'Service Plan',
  },
  ORDER_DETAIL: {
    ORDER_TYPE: 'Order Type',
    WIADVANCE_ORDER_TYPE: 'Contract Type',
    OWNER: 'Order Owner',
    WIADVANCE_ORDER_OWNER: 'Contract Owner',
    NO_REGARDING: 'Enter the company name to search',
    TIMELINE: 'Timeline',
    NO_TIMELINE: 'No Timeline',
    //----TAB      
    DETAIL: 'Detail',
    PRODUCT: 'Product',
  },
  SHIPPINH_METHODS: {
    AIR_FREIGHT: 'Air Freight',
    MAIL_DELIVERY: 'Mail Delivery',
    FULL_LOAD: 'Full Load',
    PICK_UP: 'Pick Up'
  },
  SHIPPINH_TERM: {
    FREE_SHIPPING: 'Free Shipping',
  },
  PAYMENT_TERM: {
    PAYMENT_WITHIN_30D: 'Payment within 30 days',
    PAYMENT_WITHIN_30D2PERCENT: "2% 10, Payment within 30 days",
    PAYMENT_WITHIN_45D: "Payment within 45 days",
    PAYMENT_WITHIN_60D: "Payment within 60 days",
    PAYMENT_WITHIN_90D: "Payment within 90 days",
  },
  THEDAYOFEVERYMONTH: {
    1: 'the 1st of every month',
    2: 'the 2nd of every month',
    3: 'the 3rd of every month',
    4: 'the 4th of every month',
    5: 'the 5th of every month',
    6: 'the 6th of every month',
    7: 'the 7th of every month',
    8: 'the 8th of every month',
    9: 'the 9th of every month',
    10: 'the 10th of every month',
    11: 'the 11th of every month',
    12: 'the 12th of every month',
    13: 'the 13th of every month',
    14: 'the 14th of every month',
    15: 'the 15th of every month',
    16: 'the 16th of every month',
    17: 'the 17th of every month',
    18: 'the 18th of every month',
    19: 'the 19th of every month',
    20: 'the 20th of every month',
    21: 'the 21st of every month',
    22: 'the 22nd of every month',
    23: 'the 23rd of every month',
    24: 'the 24th of every month',
    25: 'the 25th of every month',
    26: 'the 26th of every month',
    27: 'the 27th of every month',
    28: 'the 28th of every month',
    29: 'the 29th of every month',
    30: 'the 30th of every month',
    31: 'the 31st of every month',
  },
  ORDER_TYPE: {
    LICENSE_PRODUCT: 'License Contract',
    SERVICE_PRODUCT: 'Service Contract',
    LICENSE_CONTRACT: 'License Contract',
    SERVICE_CONTRACT: 'Service Contract',
  },
  AGENT: {
    ICON: 'Select Icon',
    TITLE: 'AI Agents',
    GOAL: 'Description (optional)',
    GOAL_Mandatory: 'Goal',
    IMAGE_INPUT: 'Image',
    QUESTION: 'Question',
    INSTRUCTION: 'Instruction',
    KNOWLEDGE_LIBS: 'Knowledges',
    UN_UPDATED: 'No updates',
    CUSTOMER: 'Customer',
    SOLUTION: 'Solution',
    PRODUCTS: 'Products',
    FILE: 'File Upload',
    TRANSLATE_TO: 'Translate to',
    ADD_FIELD: 'Add Field',
    FIELD_TYPE: 'Field Type',
    FIELD_NAME: 'Field Name',
    SYSTEM_NAME: 'System Name',
    DEFAULT_VALUE: 'Default Value',
    IS_MANDATORY: 'Required field',
    CHOOSE_FILE_HINT: 'Please choose a file',
    LABEL_PREVIOUS_STEP: 'Load previous step document',
    LABEL_UPGPT_KNOWLEDGE: 'Load specific document from UpGPT knowledge',
    AGENT_NAME_Construction_Compliance_Agent: 'Construction Compliance Agent',
    AGENT_NAME_Proposal_Writing_Agent: 'Proposal Writing Agent',
    AGENT_NAME_Employee_Onboarding_Agent: 'Employee Onboarding Assistant',
    AGENT_NAME_Document_Translation_Agent: 'Document Translation Assistant',
    AGENT_DESCRIPTION_Construction_Compliance_Agent: 'Finding construction site safety information, construction instructions, checklists, procedures and compliance-related materials based on photos and questions provided by users.',
    AGENT_DESCRIPTION_Proposal_Writing_Agent: 'Generate proposals based on the provided instructions, examples, and information.',
    AGENT_DESCRIPTION_Employee_Onboarding_Agent: 'Assist employees in answering onboarding-related questions, finding relevant information, and improving the overall employee experience.',
    AGENT_DESCRIPTION_Document_Translation_Agent: 'Assist employees to translate document content into designated language.',
    SEARCH_IMAGE_BY_IMAGE_NUM_IMAGE_RETURN: 'Number of images to return',
    SEARCH_KNOWLEDGE_NUM_OF_SUBQUERIES: 'Number of related questions',
    IGNORE_LANGUAGE_SETTING: 'Ignore language setting',
    OUTPUT_FORMAT: 'Output format',
    INCLUDE_IN_CITATION: 'Cite by text segment',
    STEP_user_input: 'User Input',
    STEP_search_image_by_image: 'Search Image by Image',
    STEP_read_document: 'Read Document',
    STEP_think: 'Think',
    STEP_search_knowledge: 'Search Knowledge',
    STEP_respond: 'Response',
    TEXT_MESSAGE: "Enter text",
    KNOWLEDGE_MESSAGE: "  Choose the knowledge library to use",
    STEP: "Step",
    READ_DOCUMENT_DESCRIPTION: "Read document contents...",
    THINK_DESCRIPTION: "Think and analyze...",
    SEARCH_IMAGE_BY_IMAGE_DESCRIPTION: "Search related images by image...",
    SEARCH_KNOWLEDGE_DESCRIPTION: "Search knowledge base or documents...",
    RESPOND_DESCRIPTION: "Generate response based on previous steps...",
    FOLLOW_UP_QUESTION: "Follow-up question",
    CONTENT: "Content",
    ADD_AGENT: "Add Agent",
    ADD_SIMPLE_AGENT: "Add Agent",
    EDIT_SIMPLE_AGENT: "Edit Agent",
    AGENT_NAME_MSG: "Enter agent name",
    SEARCH_WEB: "Web Search",
    BIND_LIB: 'Select knowledge base',
    BIND_FOLDER: 'Select folder',
  },
  AGENT_FILE_ATTACHMENT: {
    ATTACHMENT: "Attached Files",
    UPLOAD: "Click to select or drag files here. ",
    ACCEPT_TYPE: "Accepted file types: {file_type}",
    UPLOADING: "Uploading",
    EXCEED_MAX: "The system only supports a maximum of 3 files. Please reselect a number of files that meets the limit.",
    STILL_RUN: 'File upload in progress, please refresh the page later.',
    WRONGTYPEINFILE: 'Only pdf, docx, pptx, jpg, jpeg, and png files are accepted for file upload',
    DRAG_HINT: 'Drag files here, up to 3 files, supports .pdf .docx .pptx .jpg .png',
    EXCEED_MAX_TOAST: 'Upload up to 3 files',
    EXCEED_SIZE_TOAST: 'Total file size cannot exceed 20MB',
  },
  AGENT_STEP: {
    STEP: 'STEP',
    ANSWER: 'ANSWER',
  },
  // Document Agent
  DOCUMENT_AGENT: {
    TITLE: "AI Work Center",
    TEMPLATE_TITLE: "Select template",
    LINK_ACCOUNT: "Linked Account",
    ACCESS_FOLDER: "Access folder",
    GENERATE_CONSET_FORM: "Generate consent form",
    SYNC_UPDATE: "Sync Update",
    NO_DATA: "No data available to display",
    PROPERTIES: "Field Settings",
    REGENERATE: "Regenerate",
    SHOWALL: "Show All Data",
    DELETE_CHECK: 'Are you sure you want to delete this cloud account setting?\nOnce confirmed, all linked files will be deleted.',
    DELETE_FILE_CHECK: 'Are you sure you want to delete this data link setting?\nOnce confirmed, all linked files will be deleted.',
    NO_REFERENCE_USED: "No Reference Used",
    AI_DISCLAIMER: "AI can make mistakes. Please verify.",
    RUN_AGENT: "Run Agent",
    RUN_ALL: "Run All",
    TOTAL: "Total",
    UNSUPPORTED_FILE_FORMAT: 'Unsupported file format',
    FILE_FORMAT_TOOLTIP: 'Supports pdf, docx, pptx, xlsx, png, jpg, jpeg, gif, webp formats',
    UNSUPPORTED_FILES_SUMMARY: '{successCount} file(s) uploaded successfully.\n{failCount} file(s) have unsupported formats and failed to upload.',
    IMAGE_PAGE_INFO: "Page {page_num}, Image {image_num}",
    DOWNLOAD_FAILED: 'File download failed. Please try again later.',
    BLANK_TEMPLATE: 'Blank Template',
    CREATOR: 'Creator',
    CREATOR_ADMIN: 'Administrator',
    AI_GENERATE_TITLE: 'What would you like Work Agent to do?',
    AI_GENERATE_PLACEHOLDER: 'Enter a prompt to generate a template, or create directly',
    AI_GENERATE_BTN: 'AI Generate',
    RETRY_BTN: 'Retry',
    DIRECT_CREATE_BTN: 'Direct Create',
    SAVE_AS_TEMPLATE: 'Save as Template',
    SAVE_AS_TEMPLATE_HEADER: 'Save as Template',
    SAVE_AS_TEMPLATE_NAME: 'Name',
    SAVE_AS_TEMPLATE_DESC: 'Description',
    SAVE_AS_TEMPLATE_STATUS: 'Status',
    SAVE_AS_TEMPLATE_PRIVATE: 'Private',
    SAVE_AS_TEMPLATE_PUBLIC: 'Public',
    SAVE_AS_TEMPLATE_DUPLICATE_MSG: 'A template with this name already exists. Continue saving?',
    SAVE_AS_TEMPLATE_SAVE_BTN: 'Save',
    SAVE_AS_TEMPLATE_NAME_REQUIRED: 'Template name is required',
    DELETE_TEMPLATE_CONFIRM: 'This will permanently delete the {name} template. Are you sure?\nExisting Work Agents will continue to work normally.',
    DELETE_TEMPLATE_FAILED: 'Failed to delete template. Please try again.',
    AI_GENERATE_ERROR_TIMEOUT: 'AI generation timed out. Please retry or choose "Direct Create".',
    AI_GENERATE_ERROR_SERVICE: 'AI service error. Please retry or choose "Direct Create".',
    AI_GENERATE_ERROR_FORMAT: 'AI returned an invalid format. Please modify your prompt or choose "Direct Create".',
    AI_GENERATE_ERROR_CREATE: 'Failed to create Work Agent. Please retry or choose "Direct Create".',
    RECORD_REVIEW: 'Record Review',
    COLLECTION_LOAD_ERROR: 'Failed to load collection data',
    DATA_LOAD_ERROR: 'Failed to load field data. Please try again later',
    OPEN_FILE: 'Open File',
    FILE_TYPE_NOT_SUPPORTED: 'This file type is not supported for preview',
    FILE_LOAD_ERROR: 'Failed to load file. Please try again later',
    NO_EXTRACTED_TEXT: 'No text content available for this file',
    PREVIEW_LOAD_ERROR: 'Unable to load preview. Please try refreshing or open the file directly',
    PREVIEW_FETCH_ERROR: 'Failed to get preview link. Please try again later',
    EXTRACT_TEXT_ERROR: 'Failed to extract document text. Please try again later',
    RECORD_COUNT: '{current} / {total}',
    NO_PREVIEWABLE_FILE: 'No previewable file in this record',
    RECORD_DELETED: 'This record has been deleted',
    NO_FILE_IN_COLUMN: 'No file in this column',
    EXPAND: 'Expand',
    COLLAPSE: 'Collapse',
    VIEW_ORIGINAL_FILE: 'Original File',
    VIEW_EXTRACTED_TEXT: 'Extracted Text',
    PDF_PREVIEW_LOAD_ERROR: 'Unable to load preview. Please try switching again or open the file directly.',
    PDF_PREVIEW_FETCH_ERROR: 'Failed to fetch preview link. Please try again later.',
    REF_MODE_TEXT: "Text Mode",
    REF_MODE_PDF: "PDF Mode",
    REF_MODE_WEB: "Web Sources",
    WEB_SEARCH_EMPTY: "No web sources found for this search.",
    CELL_ERROR_DEFAULT: 'An error occurred while executing this cell.',
    CELL_ERROR_TIMEOUT: 'Execution Timeout',
    CELL_ERROR_FAILURE: 'Execution Failed',
    SORT_ASC: 'Ascending',
    SORT_DESC: 'Descending',
    SORT_CLEAR: 'Clear Sort',
    SORT_TOOLTIP: 'Click to sort, click again to toggle direction or clear',
    FILTER_CONTAINS: 'Contains',
    FILTER_NOT_CONTAINS: 'Does not contain',
    FILTER_EQUALS: 'Equals',
    FILTER_NOT_EQUALS: 'Does not equal',
    FILTER_GT: 'Greater than',
    FILTER_GTE: 'Greater than or equal to',
    FILTER_LT: 'Less than',
    FILTER_LTE: 'Less than or equal to',
    FILTER_BETWEEN: 'Between',
    FILTER_IS_EMPTY: 'Is empty',
    FILTER_IS_NOT_EMPTY: 'Is not empty',
    FILTER_APPLY: 'Apply',
    FILTER_CLEAR: 'Clear',
    FILTER_CLEAR_ALL: 'Clear all filters',
    MENU_SORT: 'Sort',
    MENU_FILTER: 'Filter',
    NO_FILTER_RESULT: 'No data matches the filter criteria',
  },
  WORK_AGENT: {
    PERMISSION_SETTINGS: 'Permission Settings',
    MANAGE_ACCESS: 'Manage Access',
    SHARE_BTN: 'Share',
    ENTITY_TYPE_TEMPLATE: 'Work Agent Template',
    ENTITY_TYPE_INSTANCE: 'Work Agent Instance',
    OWNER_LABEL: 'Owner',
    VISIBILITY_LABEL: 'Visibility',
    VISIBILITY_PRIVATE: 'Private',
    VISIBILITY_PUBLIC: 'Public',
    PRIVATE_DESCRIPTION: 'Visible only to owner and managers',
    PUBLIC_DESCRIPTION: 'All tenant users',
    MANAGER_ONLY_BANNER: 'Only managers (is_staff) can configure template visibility and sharing.',
    INSTANCE_OWNER_ONLY_INFO: 'Only the owner can configure visibility and sharing. Viewers can only view and run this Work Agent, not manage it.',
    PRIVATE_SHARING_HINT: 'When private, access must be explicitly granted. Users and groups can be added simultaneously.',
    SHARE_TO_USER: 'Share to Users',
    SHARE_TO_GROUP: 'Share to Groups',
    SEARCH_USER_PLACEHOLDER: 'Search users or email...',
    SEARCH_GROUP_PLACEHOLDER: 'Search groups...',
    SHARE_USER_DESC_TEMPLATE: 'Shared users can see this template in the template selection dialog and create Work Agents from it (read-only, cannot edit or delete the template).',
    SHARE_USER_DESC_INSTANCE: 'Shared users can view and run this Work Agent (read-only, cannot edit or delete).',
    SHARE_GROUP_DESC: 'Group membership changes take effect immediately. Visibility is resolved based on the current group member list.',
    SELECT_ALL: 'Select All',
    SAVING: 'Saving...',
    SAVED: 'Saved',
    PUBLIC_WARNING_TEMPLATE: 'Setting to public allows all tenant users to see and use this template without individual sharing. Existing specific shares will no longer affect visibility (existing settings are not deleted).',
    PUBLIC_WARNING_INSTANCE: 'Setting to public allows all tenant users to view and run this Work Agent without individual sharing. Existing specific shares will no longer affect visibility (existing settings are not deleted).',
    NO_EDIT_PERMISSION: 'You do not have permission to edit this Work Agent',
    NO_DELETE_PERMISSION: 'You do not have permission to delete this Work Agent',
    NO_MANAGE_ACCESS_PERMISSION: 'You do not have permission to manage access',
    ERROR_NO_PERMISSION: 'You do not have permission to perform this action',
    ERROR_SHARE_SAVE_FAILED: 'Failed to save access settings. Please try again later.',
    ERROR_SHARE_REMOVE_FAILED: 'Failed to remove share settings. Please try again later.',
    ERROR_ONEDRIVE_TOKEN_EXPIRED: 'Source connection is invalid. Please contact the owner to re-authorize.',
    ACCESS_REVOKED_TITLE: 'Cannot access this Work Agent',
    ACCESS_REVOKED_MESSAGE: 'Your access to this Work Agent has been changed or revoked by the owner. Please refresh the page to update the list.',
    REFRESH_PAGE: 'Refresh page',
  },
  DOCUMENT_AGENT_SELECT: {
    SELECT_FOLDER: "Select folder",
    LINK_ACCOUNT: "Linked Account"
  },
  DOCUMENT_AGENT_PROPERTY: {
    NAME: "Name",
    TYPE: "Type",
    MODEL: "Model",
    INPUT: "Input",
    DESCRIPTION: "Instruction",
    COLLECTION_PROPERTIES: "Collection Fields",
    COLLECTION_NAME_DUPLICATE: "This name is already used in the collection table, please use a different name",
    USER_PROMPT: "User Prompt",
    REASONING_EFFORT: "Reasoning Effort",
    OPTIONS: "Options",
    READ_DOCUMENTS:"Read Document",
    CHOOSE_READ_DOCUMENTS:"Please select the read document",
    CHOOSE_INPUT_COLUMN:"Please select the input column.",
    FILL_COLUMN_NAME:"Please fill in the column name",
    FILL_PROMPT:"Please fill in the prompt.",
    FILE_UPLOAD: "File Upload",
    ONEDRIVE_FILE: "OneDrive File",
    TEXT: "Text",
    NUMBER: "Number",
    COLLECTION: "Collection",
    SINGLE_SELECT: "Single Select",
    DOCUMENT_OUTPUT: "Document Output",
    ERROR_DOCUMENT_OUTPUT_IN_COLLECTION: "Document Output fields cannot be created in a collection child table.",
    ERROR_ONEDRIVE_IN_COLLECTION: "OneDrive file-type fields cannot be created in a collection child table.",
    ERROR_ONEDRIVE_ONLY_ONE: "Only 1 OneDrive file-type field is allowed per table.",
    LOADED_ALL: "All loaded",
    CONFIRM_UPDATE_TO_ONEDRIVE: "This action will delete existing data. Are you sure you want to proceed?",
    ERROR_DUPLICATE_COLUMN_NAME: "Columns cannot have duplicate names within the same table level.",
    TEMPLATE: "Template",
    TEMPLATE_PLACEHOLDER_DOCX_ONLY: "Only .docx format is accepted",
    TEMPLATE_REUPLOAD: "Re-upload",
    TEMPLATE_DELETE: "Delete",
    TEMPLATE_DELETE_CONFIRM: "Are you sure you want to delete the uploaded template?",
    TEMPLATE_FORMAT_ERROR: "Invalid format. Only .docx files are accepted.",
    COLLAPSE: "Collapse",
    EXPAND: "Expand",
    NO_DATA: "No data",
    COLLECTION_SUMMARY: "{count} collection record(s)",
    PYTHON_TOOL: "Python Tool",
    MODEL_LIST_NOT_CONFIGURED: "The Work Agent model preference for this tenant is missing or invalid. Please contact your administrator.",
    VISION_MODEL : "Vision Model",
    NO_VISION_MODEL: "No vision model is available. Please contact your administrator.",
    MODEL_LIST_LOAD_FAILED: "Could not load the model list. Please try again later.",
    PYTHON_CODE: "Code",
    PYTHON_CODE_HINT: "Assign the output to result. Input fields are available as variables.",
    PYTHON_CHAR_COUNT: "Current: {count} / 5,000 characters",
    CONFIRM_LEAVE_PYTHON: "Switching away from Python Tool will discard the current script. Continue?",
    TOOL_SELECTOR_LABEL: "Tool",
    TOOL_OPTION_NONE: "(None)",
    VALIDATION_EMPTY_SCRIPT: "Code cannot be empty.",
    VALIDATION_MISSING_RESULT: "The script must assign a value to 'result'.",
    VALIDATION_SYNTAX_ERROR: "Syntax error on line {line}: {message}",
    VALIDATION_OVER_LIMIT: "Script exceeds the 5,000 character limit ({n} characters).",
    VALIDATION_SERVICE_UNAVAILABLE: "Validation service is temporarily unavailable. Please try again later.",
    VALIDATION_UNDECLARED_VARIABLE: "Undeclared variable(s) in script: {vars}. If an input field was renamed, please update the variable name(s) in the script accordingly.",
    EXECUTION_ERROR_TIMEOUT: "Execution timed out.",
    EXECUTION_ERROR_NO_RESULT: "The script did not produce a result.",
    EXECUTION_ERROR_SESSION_FAILURE: "Failed to start execution session.",
    EXECUTION_ERROR_TYPE_MISMATCH: "Result is not a valid number.",
    EXECUTION_ERROR_SESSION_UNAVAILABLE: "Execution session is temporarily unavailable. Please try again later.",
    WEB_SEARCH_HINT: "Bing search results will be automatically injected into context. Use [[field description]] to reference input field values.",
    WEB_SEARCH_TOOL: "Web Search Tool",
    WEB_SEARCH_ERROR_API: "Web search service is unavailable. Please try again later.",
    WEB_SEARCH_ERROR_QUOTA: "Search service is temporarily unavailable. Please try again later.",
    WEB_SEARCH_ERROR_SAVE: "Failed to save search results.",
    WEB_SEARCH_ERROR_TIMEOUT: "Execution timed out.",
    PROVIDER_UNREACHABLE_ERROR: "AI service is temporarily unreachable. Please try again later or contact your administrator.",
    PROVIDER_AUTH_FAILED_ERROR: "AI service authentication failed. Please verify the API key configuration.",
    STRUCTURED_OUTPUT_PARSE_ERROR: "Failed to parse AI output format. Please try again.",
    DOCUMENT_OUTPUT_ERROR_SYNTAX: "Template syntax error. Please check the Jinja tag format in your Word template.",
    DOCUMENT_OUTPUT_ERROR_MISMATCH: "Template does not match the current Agent data structure. Please verify the field names.",
    DOCUMENT_OUTPUT_ERROR_RENDER: "Document generation failed. Please check that the template format is correct.",
    PDF_AS_IMAGE: "Analyze PDF as Image",
    PDF_AS_IMAGE_HINT: "Each page of the PDF will be converted to an image for AI analysis. Applies to PDF files only.",
    IMAGE_ERROR_PDF_PAGES_EXCEEDED: "PDF exceeds the image limit ({n}>{x})",
    IMAGE_ERROR_INPUT_IMAGES_EXCEEDED: "The number of referenced images ({n}) exceeds the image limit ({x})",
    IMAGE_ERROR_MODEL_UNSUPPORTED: "The selected model {x} does not support image input",
    INPUT_FILE_ERROR: "Input field \"{x}\" failed to process. Please fix it and run again.",
    INPUT_PDF_NOT_READY: "The PDF in input field \"{x}\" has not been reprocessed with the current setting. Please run that file field first.",
  },
  //Up Portal
  MenuBarPortal: {
    NEW_THREAD: 'New Thread',
    LIBRARY: 'Library',
    THREAD_HISTORY: 'History',
  },
  MAIN_PORTAL_VIEW: {
    INTRO: 'What can I help you with?',
  },
  PORTAL: {
    SHARE: 'Share',
    REFERENCE: 'Reference',
    ANSWER: 'Answer',
    KNOWLEDGE: 'Knowledge',
    APPLY: 'Apply',
    Related: 'Related',
    RelatedImages: 'Related Images',
    ViewLess: 'View less',
    ViewMore: 'View more',
    ERROR_1: 'The AI server is busy, please try again later.',
    ERROR_2: 'AI is generating, please refresh later',
    MISS_CONTENT_TITLE: "File not found.",
    MISS_CONTENT_DETAIL: "The resource you are looking for might have been deleted.",
    NO_RELATED_ANSWER: "There’s no information!",
    ANSWER_INTERRUPTED: "This answer was not completed. Please click \"Rewrite\" to try again.",
    HELPFUL: 'Helpful',
    UNHELPFUL: 'Unhelpful',
    COPY: 'Copy',
    REWRITE: 'Rewrite',
    MESSAGE_DELETE: 'Please make sure to delete ',
    DELETE_AGENT_CONFIRM: 'This will delete {agent}, are you sure?',
    DELETE_COLUMN_CONFIRM: 'This will delete column {column}, are you sure?',
    DONT_DELETE: 'Don\'t delete',
    CONFIRM_UPDATE: 'Confirm update',
    CONFIRM_DELETE: 'Confirm',
    ERROR_3: 'Oops, we ran into a little problem. Please help me out by clicking "Rewrite" below.',
    MY_KNOWLEDGE: 'Private Knowledge',
    THINKING_GENERATE: 'Reasoning',
    NO_REFERENCE: 'No reference available',
    MORE_RISK: "The following answer carries a higher risk",
    NO_REFERENCE_MESSAGE: 'No references were included in this response. The AI reply may be inaccurate. Consider adding more content to the knowledge base, or provide a more complete and specific prompt to improve response quality.(If you have uploaded a file, please add the prompt:"Based on the document I uploaded", before asking your question.)',
    WEB_SOURCE: "Source：",
    ERROR_4: "The connection has been lost. Please refresh the page.",
    DELETE_ROWS_CONFIRM_MESSAGE: "This action will delete {count} {tableName} record(s) and related child records. Are you sure you want to delete?",
    FAVORITES: 'Favorite Knowledge',
    FAVORITE_SHORT: 'Favorite',
    ADD_TOOL_KNOWLEDGE: 'Add tools & knowledge',
  },
  TENANTCENTER: {
    TITLE: 'Tenant Center',
    TENANTLIST: 'Tenant List',
    USAGE_ANALYSIS: 'Usage Analysis',
    CREATE_TENANT: 'Create Tenant',
    CREATE_SUPERUSER: 'Create Super User',
    UPDATE_SUBSCRIPTION: 'Update Subscription Date',
    LOGOUT: 'Log out',
    CREATE: 'Create',
  },
  TENANTCENTER_SUMMARY: {
    MONTH_USAGE: 'Usge',
    RANK_TABLE_HEADER_1: 'Storage Usage(G)',
    RANK_TABLE_HEADER_2: 'IDP Used(Page)',
    RANK_TABLE_HEADER_3: 'IDP Storage(Page)',
    RANK_TABLE_HEADER_4: 'Image Used(Pic)',
    RANK_TABLE_HEADER_5: 'Image Storage(Pic)',
    RANK_TABLE_HEADER_6: 'Remaining Amount(USD)',
    RANK_TABLE_HEADER_7: 'Recharge Amount(USD)',
  },
  TENANTCENTER_TENANT_LIST: {
    SCHEMANAME: 'Schema Name',
    TENANTNAME: 'Tenant Name',
    DESCRIPTION: 'Description',
    CREATED_ON: 'Created On',
    EXPIRATION: 'Subscription Expiration',
    LICENSED: 'Number of Licensed',
    ACTION: 'Action',
  },
  ADD_TENANT: {
    TITLE: 'Create Tenant',
    TENANTNAME: 'Tenant Name',
    DESCRIPTION: 'Description',
    LICENSED: 'Number of Licensed',
    NAME_HINT: "Must be Unique, and can't be modified after created.",
    LICENSED_HINT: 'After the tenant is established, the number of new account that can be added',
    ADD_TENANT_WAIT: 'Tenant creation is in progress, this may take a while. You can click Update later to confirm that the creation has been completed.',
    PROCESSING: 'Building, please wait'
  },
  TENANTCENTER_USER_LIST: {
    LIST: 'User List',
    USERNAME: 'User Name',
    FIRSTNAME: 'First Name',
    LASTNAME: 'Last Name',
    EMAIL: 'Email',
    SUPERUSER: 'Super User',
    ADMIN: 'Admin',
    ACTIVE: 'Active',
    LOGIN_DATE: 'Last Login',
    JOIN_DATE: 'Date Joined',
  },
  ADD_SUPERUSER: {
    TITLE: 'Create Super User',
    TENANTNAME: 'Tenant Name',
    SELECT_TENANT: 'Select Tanent',
    LASTNAME: 'Last Name',
    FIRSTNAME: 'First Name',
    USERNAME: 'User Name',
    EMAIL: 'Email',
    PASSWORD: 'Password',
    PASSWORD__HINT: 'Password must contain at least 8 characters, at least one uppercase character (A-Z) at least one number chracter (0...9), at least one special chracter.'
  },
  TENANT_PIPELINE: {
    CREATE: 'Create',
    BUTTON: 'Set Up Tenant by Flow',
    TITLE: 'Set Up Tenant by Flow',
    STAGE_TENANT: 'Select Tenant',
    STAGE_ADMIN: 'System Admins',
    STAGE_UPCHAT: 'Enable UpChat',
    STAGE_PORTAL: 'Enable UpGPT Portal',
    STAGE_WORK_AGENT: 'Enable Work Agent',
    STAGE_UPAGENT: 'Enable UpAgent',
    CURRENT_TENANT: 'Tenant',
    PREVIOUS: 'Back',
    NEXT: 'Next',
    UPDATE: 'Update',
    FINISH: 'Finish',
    UPDATING: 'Updating...',
    FORM_INVALID: 'Please fix the highlighted fields first.',
    PARTIAL_FAILED: 'Some items did not complete. See the messages below.',
    MODE_EXISTING: 'Existing tenant',
    MODE_NEW: 'New tenant',
    TENANT_EXISTS: 'Tenant name already exists.',
    CREATING_TENANT: 'Creating tenant...',
    LOADING_SEED: 'Loading seed data...',
    SEED_FAILED: 'The tenant was created, but seed data failed to load. Click Create to retry loading seed data.',
    SEED_RETRY_HINT: 'The tenant already exists. Clicking Create only retries loading seed data.',
    ADMIN: 'Admin',
    ADD_ADMIN: 'Add admin',
    GENERATE_PASSWORD: 'Generate',
    CREATING_ACCOUNT: 'Creating accounts...',
    ADMIN_CREATED: 'Created',
    ADMIN_PARTIAL_FAILED: '{failed} of {total} accounts failed. Fix them and click Create again.',
    NAME: 'Name',
    UPCHAT_USER: 'UpChat account',
    UPCHAT_ACCOUNT: 'UpChat Account',
    CREATED: 'Created',
    NOT_CREATED: 'Not created',
    NO_SUPERUSER: 'This tenant has no system admins yet.',
    ENABLE_PORTAL_KNOWLEDGE: 'Enable UpGPT Portal knowledge base',
    ENABLE_IMAGE_SEARCH: 'Enable image search',
    STORAGE_SIZE: 'Knowledge storage limit (GB)',
    IMAGE_SEARCH_STORE: 'Image search limit (images)',
    SEARCH_SERVICE: 'Search service',
    FROM_PREFERENCE: 'From tenant {tenant} settings',
    UNREACHABLE: 'Unreachable',
    ORPHAN_INDEX: 'Not mapped to any tenant',
    PORTAL_BOT_SOURCE: 'Copy UpGPT Portal AI Bot from tenant',
    PORTAL_BOT_EXISTS: 'This tenant already has an UpGPT Portal AI Bot: {name}',
    NO_PORTAL_BOT_SOURCE: 'No other tenant has an UpGPT Portal AI Bot to copy',
    ENABLE_WORK_AGENT: 'Enable Work Agent',
    MAX_THREAD: 'Work Agent max threads',
    WORK_AGENT_DISABLE_HINT: 'Work Agent will be disabled for this tenant. The thread limit and model list are kept.',
    ENABLE_UPAGENT: 'Enable UpAgent',
    ACTIVATION_CODE: 'Activation code',
    COPY: 'Copy',
    UPAGENT_DISABLE_HINT: 'The activation code will be deleted and can no longer activate UpAgent. The model list is kept.',
    INCLUDE_NATIVE_AOAI: 'Include native AOAI models',
    DISPLAY_NAME: 'Display name',
    KEY_LOCKED: 'The key of an existing model cannot be changed',
    KEY_DUPLICATED: 'Duplicate key',
    COST_KEY_HINT: 'Leave empty if this model is not billed',
    DEFAULT_MODEL: 'Default model',
    DEFAULT_MODEL_HINT: 'If empty, the first model is the default',
  },
  //Other
  BUSINESS_TYPE: {
    OPPTY: "Opportunity",
    CASE: "Case",
    COMPANY: "Company",
    CONTACT: "Contact",
    AI_NOTEBOOK: "AINotebook",
  },
  WIADVANCE: {
    MESSAGE_1: "Please enter at least one product and confirm the required fields. Business Type, Customer Code, Net Amount, Estimated Gross Profit, Profit",
    MESSAGE_2: "Please confirm that the selected opportunity has at least one product and confirm the required fields.Business Type, Customer Code, Net Amount, Estimated Gross Profit, Profit",
  },
  ENTRAIDSYNC: {
    TITLE: "Entra ID Sync",
    INSTRUCTION: "Please select Entra ID users to synchronize.",
    SELECTED: "Selected",
    EMAIL: "Email",
    FIRST_NAME: "First Name",
    LAST_NAME: "Last Name",
    SYNC: "Synced",
    BUSINESS_PHONES: "Business Phone",
    OFFICE_LOCATION: "Office Location",
    JOB_TITLE: "Job Title",
    PORTAL_USER: 'Portal User',
  },
  LOGIN_PAGE_SETTING: {
    TITLE: "Custom Settings",
    SECTION_TITLE: "Login Page Settings",
    SAVE: "Confirm",
    SAVE_SUCCESS: "Saved successfully",
    SAVE_ERROR: "Save failed, please try again",
    LOGO_IMAGE: "Company Logo",
    LOGO_HINT: "Best size: 360×80px, format: png",
    BG_IMAGE: "Background Image",
    BG_HINT: "Best size: 1440×900, format: jpg",
    TITLE_TEXT: "Title Text",
    TITLE_TEXT_PLACEHOLDER: "Welcome",
    TITLE_TEXT_HINT: "Limit: 20 characters (approx. 10 Chinese characters)",
    TITLE_COLOR: "Title Color",
    SUBTITLE_TEXT: "Subtitle Text",
    SUBTITLE_TEXT_PLACEHOLDER: "Ready to start a great conversation with UpGPT?",
    SUBTITLE_TEXT_HINT: "Limit: 50 characters (approx. 10-25 Chinese characters)",
    SUBTITLE_COLOR: "Subtitle Color",
    LOGIN_BUTTON: "Login Button",
    BUTTON_COLOR: "Button Color",
    BUTTON_TEXT_COLOR: "Text Color",
    COLOR_UNSET: "Not set",
    LOGIN_URL_LABEL: "Login URL",
    LOGIN_URL_DESC: "Use this URL to access the login page with your brand customization applied",
    PORTAL_URL_LABEL: "UpGPT Portal",
    CONSOLE_URL_LABEL: "UpGPT Console",
    COPY: "Copy",
    COPY_SUCCESS: "Copied",
    IMG_FORMAT_ERROR_LOGO: "Invalid format for Logo. Please upload a PNG file",
    IMG_FORMAT_ERROR_BG: "Invalid format for Background. Please upload a JPG file",
    IMG_SIZE_ERROR: "Image size exceeds 5MB. Please choose another file",
  },
  URBANRENEWAL_ADMIN: {
    SYSTEM_TITLE: "Urban Renewal Selection System — Admin",
    PG: {
      TOTAL: 'Total {count}',
      RPP: '{n} / page',
    },
    CURRENT_PROJECT: "Current Project",
    PROJECT_LABEL: "Project",
    NO_PROJECTS: "No projects",
    NAV_BASIC: "Basic Info",
    NAV_STATISTICS: "Statistics",
    NAV_HEATMAP: "Selection Status",
    NAV_SIMULATION: "Simulation",
    NAV_MANUAL: "Manual Entry",
    PROJECT_SETTINGS: "Project Settings",
    ADMIN_SETTINGS: "Admin Settings",
    LOGOUT: "Logout",
    GEAR_MENU: "Settings Menu",
    LOGIN: {
      WELCOME: 'Welcome Back',
      TITLE: 'Sign In',
      ACCOUNT: 'Account',
      PASSWORD: 'Password',
      SUBMIT: 'Sign In',
      FORGOT: 'Forgot Password',
      ERR_REQUIRED: 'Please enter account and password',
      ERR_INVALID: 'Incorrect account or password',
      ERR_NO_ACCESS: 'No admin access permission',
      ERR_NO_TENANT: 'Unable to identify tenant. Please check the login URL',
      COPYRIGHT: 'ART Solutions All Rights Reserved.',
    },
    PROJECT: {
      TITLE: 'Project Settings',
      ADD: 'Add Project',
      NAME: 'Project Name',
      START: 'Selection Start Date',
      DEADLINE: 'Selection End Date',
      SAVE: 'Save',
      SAVED: 'Saved',
      DELETE: 'Delete',
      EXPIRED: 'Ended',
      NAME_REQUIRED: 'Please enter a project name',
      DELETE_CONFIRM: 'Delete project "{name}"? This cannot be undone.',
      DELETE_HAS_DATA: 'This project has related data and cannot be deleted.',
      CANCEL: 'Cancel',
      CLOSE: 'Close',
      BACK: 'Back',
      SAVE_FAILED: 'Save failed, please retry.',
    },
    PERIOD_LABEL: 'Selection Period',
    NO_PERIOD: 'Selection period not set',
    LANDOWNER: {
      TAB_LANDOWNER: 'Landowners',
      TAB_HOUSING: 'Housing Units',
      TAB_PARKING: 'Parking Units',
      WIP: 'Under Development',
      PRIORITY_ZONE: 'Priority Zone',
      NAME: 'Owner',
      ACCOUNT: 'Account',
      PASSWORD: 'Password',
      ADDRESS: 'Building Address',
      LAND_SHARE: 'Land Share',
      PARKING_ALLOCATION: 'Parking Allocation',
      PARKING_VALUE: 'Parking Value (NTD)',
      PRE_RATIO: 'Pre-update Ratio (%)',
      PRE_VALUE: 'Pre-update Value (NTD)',
      SELECTABLE_VALUE: 'Selectable Value (NTD)',
      ALLOCATED_VALUE: 'Allocated Value (NTD)',
      ACTION: 'Action',
      IMPORT: 'Import Excel',
      EXPORT: 'Export Excel',
      DELETE: 'Delete',
      DELETE_N: 'Delete {count}',
      REGEN_PASSWORD: 'Regenerate Password',
      COPY: 'Copy',
      COPIED: 'Copied',
      DELETE_CONFIRM: 'Delete the selected {count} landowner(s)? This cannot be undone.',
      DELETE_CONFIRM_ROWS: 'Delete the selected {count} row(s)? This cannot be undone.',
      CANCEL: 'Cancel',
      CLOSE: 'Close',
      CONFIRM: 'Confirm',
      REGEN_TITLE: 'New Password',
      REGEN_HINT: 'Please copy and share this with the landowner (not sent automatically).',
      IMPORT_ERROR_TITLE: 'Import Result',
      IMPORT_SUMMARY: 'Imported: {created} created, {updated} updated. The following rows were skipped:',
      IMPORT_SUCCESS: 'Import complete: {created} created, {updated} updated, no errors.',
      COL_ROW: 'Row',
      COL_REASON: 'Error',
      IMPORT_FAILED: 'Import failed. Please check the file format.',
      SAVE_FAILED: 'Save failed. Please retry.',
      TOTAL: '{count} records',
      RPP: 'Per page',
      NO_DATA: 'No data',
      SELECT_PROJECT: 'Please select a project',
      LOADING: 'Loading...',
    },
    HOUSING: {
      PRIORITY_ZONE: 'Priority Zone',
      CODE: 'Unit No.',
      AREA: 'Area (ping)',
      UNIT_PRICE: 'Unit Price (/ping)',
      TOTAL_PRICE: 'Total Price',
      SALES_UNIT_PRICE: 'Sale Unit Price',
      SALES_TOTAL_PRICE: 'Sale Total Price',
    },
    PARKING: {
      CODE: 'Parking No.',
      SPEC: 'Spec',
      TYPE: 'Type',
      VALUE: 'Value',
    },
    STAT: {
      TAB_LANDOWNER: 'Landowner Stats',
      TAB_HOUSING: 'Housing Stats',
      TAB_PARKING: 'Parking Stats',
      WIP: 'Coming Soon',
      FILTER_ZONE: 'Priority Zone',
      FILTER_NAME: 'Search Owner',
      FILTER_STATUS: 'Selection Status',
      ALL: 'All',
      COUNT: '{count} landowner groups',
      COL_ZONE: 'Priority Zone',
      COL_OWNER: 'Owner(s)',
      COL_HOUSE: 'Selected Unit(s)',
      COL_PARKING: 'Selected Parking(s)',
      COL_SELECTION_TOTAL: 'Selection Total (NTD)',
      COL_MAKEUP: 'Est. Makeup (NTD)',
      COL_MAKEUP_STATUS: 'Makeup Status',
      COL_SELECTION_STATUS: 'Selection Status',
      COL_OVER_RATIO: 'Over-selection %',
      SEL_LOW: 'Under',
      SEL_NORMAL: 'Normal',
      SEL_OVER: 'Over',
      MK_REFUND: 'Refundable',
      MK_PAY: 'Payable',
      DASH: '—',
      EXPORT: 'Export Excel',
      NO_DATA: 'No Data',
      SELECT_PROJECT: 'Please select a project',
      LOAD_FAILED: 'Load failed',
      EXPORT_FAILED: 'Export failed',
      SEARCH_HOUSE: 'Search unit no.',
      SEARCH_PARKING: 'Search parking no.',
      FILTER_CATEGORY: 'Category',
      CAT_NORMAL: 'Normal',
      CAT_NONPRIORITY: 'Non-priority',
      CAT_OVER: 'Over',
      HS_COL_ZONE: 'Priority Zone',
      HS_COL_CODE: 'Unit No.',
      HS_COL_NORMAL: 'Normal Selection',
      HS_COL_NONPRIORITY: 'Non-priority Selection',
      HS_COL_OVER: 'Over-selection',
      PS_COL_CODE: 'Parking No.',
      PS_COL_NORMAL: 'Normal Selection',
      PS_COL_OVER: 'Over-selection',
      COL_GROUP_COUNT: 'Group Count',
      UNIT_GROUP: 'group(s)',
      COUNT_ROWS: '{count} rows',
    },
    HEATMAP: {
      TAB_HOUSING: 'House Selection',
      TAB_PARKING: 'Parking Selection',
      WIP: 'Coming soon',
      EXPORT_PDF: 'Export PDF',
      EXPORT_EXCEL: 'Export Excel',
      EXPORT_FAILED: 'Export failed, please try again later.',
      PDF_TITLE: 'House Selection Heatmap',
      PDF_FAILED: 'PDF export failed. Please allow pop-ups and retry.',
      TT_UNIT_CODE: 'Unit No.',
      TT_AREA: 'Area',
      TT_UNIT_PRICE: 'Unit Price (NTD/ping)',
      TT_TOTAL_PRICE: 'Total Price (NTD)',
      TT_SPEC: 'Spec',
      TT_TYPE: 'Type',
      TT_VALUE: 'Value',
      TT_COUNT: 'Selections',
      TT_OWNERS: 'Owners',
      TT_NORMAL: 'Normal',
      TT_NONPRIORITY: 'Non-priority',
      TT_OVER: 'Over',
      U_PING: ' ping',
      U_YUAN: ' NTD',
      UNIT_GROUP: 'group(s)',
      LGD_NONE: '0 selections',
      LGD_ONE: '1 selection',
      LGD_MULTI: 'Multiple',
      LOAD_FAILED: 'Load failed',
      NO_DATA: 'No data',
      SELECT_PROJECT: 'Please select a project',
      PDF_TITLE_PARKING: 'Parking Selection Heatmap',
      TT_CODE: 'Parking No.',
    },
    SIM: {
      OWNER_SECTION: 'Landowner',
      SELECT_SECTION: 'Unit Selection',
      RESULT_BASIC: 'Basic Info',
      RESULT_SELECTION: 'Selection Summary',
      OWNER_NAME: 'Landowner name',
      HOUSE_CODE: 'Unit No.',
      PARKING_CODE: 'Parking No.',
      ALLOCATED: 'Allocated Value',
      SELECTABLE: 'Selectable Value',
      SELECTION_TOTAL: 'Selection Total',
      SELECTION_RATIO: 'Selection Ratio',
      MAKEUP: 'Est. Makeup Amount',
      ADD_OWNER: 'Add Landowner',
      ADD_HOUSE: 'Add Unit',
      ADD_PARKING: 'Add Parking',
      CALC: 'Calculate',
      RESET: 'Reset',
      RESULT_TITLE: 'Simulation Result',
      REFUND: 'Refundable',
      PAY: 'Payable',
      CANNOT_CALC: 'Cannot calculate',
      CLEAR_ALL: 'Clear all',
      NAME_HEADER: 'Name',
      COL_UNIT_CODE: 'Selected unit',
      COL_DUP_GROUP: 'Duplicate groups',
      HOUSE_ITEM: 'Unit',
      PARK_ITEM: 'Parking',
      FORMULA_CASE_A: 'Total ≤ Allocated×110% ({threshold} NTD)',
      FORMULA_CASE_B: 'Total > Allocated×110% ({threshold} NTD)',
      BALANCE_DEFICIT: 'Amount payable',
      PH_OWNER: 'Select landowner',
      PH_HOUSE: 'Select unit',
      PH_PARKING: 'Select parking',
      SEARCH_PH: 'Search…',
      NO_RESULT: 'No results',
      OWNER_ITEM: 'Owner',
      GROUP_UNIT: 'group(s)',
      LOAD_FAILED: 'Load failed',
      SELECT_PROJECT: 'Please select a project',
      HINT_CALC: 'Select a landowner and house/parking on the left, then click Calculate',
    },
    MANUAL: {
      OWNER: 'Owner',
      HOUSE: 'House',
      PARKING: 'Parking',
      GRP_COL: 'No.',
      SUB_OWNER: 'O',
      SUB_HOUSE: 'H',
      SUB_PARK: 'P',
      DELETE_COL: 'Delete column',
      ACTION: 'Action',
      SORT_LABEL: 'Sort',
      SORT_NONE: 'No sort',
      SORT_NAME: 'By owner',
      SORT_ZONE: 'By priority zone',
      IMPORT: 'Import Excel',
      EXPORT: 'Export Excel',
      SAVE: 'Save',
      ADD_ROW: 'Add Row',
      ADD_COL: '＋ {name} column',
      DELETE: 'Delete',
      CHANGELOG: 'Change Log',
      CHANGELOG_EMPTY: 'No change log yet',
      CLOSE: 'Close',
      OP_ADD: 'Add',
      OP_DELETE: 'Delete',
      SAVE_SUCCESS: 'Saved',
      SAVE_WARN: 'Saved, but {count} non-existent code(s) were skipped',
      SAVE_FAILED: 'Save failed, please try again.',
      IMPORT_FAILED: 'Import failed, please check the file format.',
      EXPORT_FAILED: 'Export failed, please try again later.',
      IMPORT_ERROR_TITLE: 'Import Failed',
      IMPORT_WARN_TITLE: 'Imported (some skipped)',
      IMPORT_WARN_INTRO: 'Import done. The following could not be resolved and were skipped (add them via the dropdown on screen):',
      NO_DATA: 'No data. Add a row or import.',
      SELECT_PROJECT: 'Please select a project',
      LOAD_FAILED: 'Load failed',
    },
    BRANDING_TITLE: 'Brand Logo',
    UPLOAD_LOGO: 'Upload Logo',
    REMOVE_LOGO: 'Remove Logo',
    LOGO_UPLOADED: 'Logo updated',
    LOGO_REMOVED: 'Logo removed',
    LOGO_UPLOAD_FAILED: 'Logo upload failed, please try again',
    LOGO_INVALID_TYPE: 'Only image files are allowed (png / jpg / gif / webp, etc.)',
    LOGO_HINT: 'Recommended: PNG with transparent background',
    AI_SUPPORT: {
      TITLE: 'AI Support',
      ENABLE: 'Enable AI support',
      URL: 'Service URL',
      URL_PH: 'e.g. https://chat.upday.ai',
      TOKEN: 'Website Token',
      TOKEN_PH: 'Paste the UpChat web-chat websiteToken',
      SAVE: 'Save',
      SAVED: 'Saved',
      SAVE_FAILED: 'Save failed, please retry',
    },
    ADMINS: {
      TITLE: 'Admin Settings',
      ADD: 'Add Admin',
      COL_EMAIL: 'Email',
      COL_LAST_NAME: 'Last Name',
      COL_FIRST_NAME: 'First Name',
      COL_STATUS: 'Status',
      COL_LAST_LOGIN: 'Last Login',
      STATUS_ACTIVE: 'Active',
      STATUS_INACTIVE: 'Disabled',
      SAVE: 'Save',
      DELETE: 'Disable',
      REACTIVATE: 'Reactivate',
      DELETE_CONFIRM: 'Disable admin "{name}"? Their backend access will be revoked.',
      CREATED: 'Admin created and invitation email sent',
      REACTIVATED: 'Admin reactivated',
      SAVED: 'Saved',
      EMAIL_REQUIRED: 'Please enter a valid Email',
      EMAIL_DUP: 'This Email is already an admin. If disabled, use Reactivate instead.',
      SAVE_FAILED: 'Operation failed, please try again',
      LOAD_FAILED: 'Load failed',
      CANCEL: 'Cancel',
      CLOSE: 'Close',
      CONFIRM: 'Confirm',
      NO_DATA: 'No admins yet',
      EDIT: 'Edit',
      BACK: 'Back',
      ACCOUNT: 'Account',
      PH_LAST: 'Last name',
      PH_FIRST: 'First name',
      PH_EMAIL: 'name@company.com',
    },
  },
  URBANRENEWAL_SELECT: {
    LOGIN: {
      WELCOME: 'Urban Renewal Selection System',
      SYS_DESC: 'Please log in with your assigned account to select and estimate your unit and parking space.',
      TITLE: 'Login',
      ACCOUNT: 'Account',
      PASSWORD: 'Password',
      SUBMIT: 'Login',
      FORGOT: 'Forgot Password',
      ERR_REQUIRED: 'Please enter account and password',
      ERR_INVALID: 'Incorrect account or password',
      ERR_NO_TENANT: 'Unable to identify tenant. Please check the login URL',
      COPYRIGHT: 'ART Solutions All Rights Reserved.',
    },
    FORGOT: {
      TITLE: 'Forgot Password',
      DESC: 'Please enter your account (email) and we will send you a password reset link.',
      ACCOUNT: 'Account (Email)',
      SUBMIT: 'Send Reset Link',
      DONE: 'If the account exists, a password reset link has been sent to your email.',
      BACK_LOGIN: 'Back to Login',
      ERR_REQUIRED: 'Please enter your account',
    },
    RESET: {
      TITLE: 'Reset Password',
      NEW_PWD: 'New Password',
      CONFIRM_PWD: 'Confirm New Password',
      SUBMIT: 'Confirm Reset',
      SUCCESS: 'Your password has been reset. Please log in with your new password.',
      ERR_REQUIRED: 'Please enter a new password',
      ERR_MISMATCH: 'The two passwords do not match',
      ERR_INVALID: 'This link is invalid or has expired. Please request a new one.',
      BACK_LOGIN: 'Back to Login',
    },
    LAYOUT: {
      SYSTEM_TITLE: 'Urban Renewal Unit & Parking Selection System',
      LOGOUT: 'Logout',
    },
    STATUS: {
      DRAFT: 'In Progress',
      SUBMITTED: 'Saved',
      LOCKED: 'Locked (Deadline Passed)',
    },
    PERIOD_LABEL: 'Selection Period',
    LAST_UPDATED: 'Last Updated',
    STATS_UPDATED: 'Statistics last updated',
    PANEL: {
      INTRO_LINE1: 'Please complete your housing and parking selection before {deadline}.',
      INTRO_LINE2: 'You may modify your data anytime before the deadline; once it passes, no further changes can be made.',
      BASIC_INFO: 'Basic Information',
      OWNER_LABEL: 'Owner {no}:',
      OWNER: 'Landowner',
      ALLOCATED: 'Allocated Value:',
      SELECTABLE: 'Selectable Value:',
      CURRENCY_UNIT: '元',
      SELECTION_LIST: 'Selection Summary',
      MOBILE_VIEW_GRID: 'Selection Map',
      MOBILE_BACK: 'Back to Summary',
      HOUSE: 'Housing Selection',
      PARKING: 'Parking Selection',
      AREA_PING: 'Area (ping)',
      UNIT_PRICE: 'Unit Price (per ping)',
      TOTAL_PRICE: 'Total Price',
      SPEC: 'Spec',
      VALUE: 'Value',
      SELECTED_GROUPS: '{count} selected',
      COL_UNIT_CODE: 'Floor / Unit',
      COL_GROUP_COUNT: 'Groups',
      HOUSE_ROW: 'Unit {no}:',
      PARKING_ROW: 'Parking {no}:',
      ADD_HOUSE: 'Add Unit',
      ADD_PARKING: 'Add Parking',
      SEARCH: 'Search…',
      NO_OPTIONS: 'No options',
      UNIT_PH_HOUSE: 'Select a house unit',
      UNIT_PH_PARK: 'Select a parking unit',
      SELECT_TOTAL: 'Selection Value Total:',
      MAKEUP_TITLE: 'Makeup Estimate',
      MAKEUP_REFUND: 'Refund Amount:',
      MAKEUP_PAY: 'Amount Due:',
      MAKEUP_NONE: 'Makeup Amount:',
      AMOUNT_NOTE: '※ The amounts above are for reference only; the actual values are subject to the rights conversion approval and final selection result.',
      DISCLAIMER: 'This table is a preliminary statistic based only on the submitted paper originals of the "Updated Allocation Location Application" and the "Combined Allocation Agreement", and is not the final selection result. The final housing and parking selection result shall be subject to the selection and lottery results announced at the public lottery meeting.',
      CLEAR_ALL: 'Clear All',
      EXPORT: 'Export Excel',
      SAVE: 'Save & Download',
      REMOVE: 'Remove',
      SAVE_SUCCESS: 'Selection result saved and image downloaded.',
      SAVE_FAIL: 'Save failed',
      EXPORT_FAIL: 'Export failed',
      EXPORT_NEED_SAVE: 'Please save before exporting.',
      EXPORT_DIRTY: 'You have unsaved changes. Please save before exporting.',
      EXPORT_FILENAME: 'selection-estimate.xlsx',
    },
    GRID: {
      UNIT_GROUP: 'group(s)',
      LGD_NONE: '0 selections',
      LGD_ONE: '1 selection',
      LGD_MULTI: 'Multiple selections',
      LGD_NONPRIORITY: 'Non-priority zone',
      OVER_LIMIT_WARN: 'Your total selected value has exceeded 110% of the allocated value. Please re-select.',
      NO_DATA: 'No data available',
    },
    UNIT: {
      AREA_PING: 'Area (ping)',
      UNIT_PRICE: 'Unit Price (per ping)',
      TOTAL_PRICE: 'Total Price',
      SPEC: 'Spec',
      VALUE: 'Value',
      SELECTED_GROUPS: 'Selected Groups',
      LINE_AREA: 'Area: {v} ping',
      LINE_UNIT_PRICE: 'Unit Price (NTD/ping): {v}',
      LINE_TOTAL_PRICE: 'Total Price (NTD): {v}',
      LINE_SPEC: 'Spec: {v}',
      LINE_GROUPS: 'Selected groups: {v}',
      ADD_SELECTION: 'Add Selection',
      ALREADY_ADDED: 'This unit is selected',
      CANCEL_SELECTION: 'Cancel this selection',
      CLOSE: 'Close',
      NONPRIORITY_WARN: 'Reminder: The unit you are selecting is not within your priority selection zone under the selection rules. If another owner within the priority zone also applies for this unit during the selection period, you may not be allocated this unit. Please consider adjusting your selection. We apologize for any inconvenience.',
      NONPRIORITY_HINT: 'This unit is not within your priority zone. If it overlaps with a priority-zone owner’s selection, it cannot be allocated by lottery.',
    },
    OVER: {
      TITLE: 'Selection Limit Exceeded',
      CONFIRM: 'Confirm',
    },
    DIALOG: {
      INTRO_TITLE: 'Selection Estimate Reminder',
      INTRO_PERIOD_LABEL: 'Current selection period:',
      INTRO_PERIOD_RANGE: 'From {start} to {end}',
      INTRO_BODY: 'The unit/parking selection and makeup amount in this system are for estimation reference only. Please submit the paper original of the "Updated Allocation Location Application" and the "Combined Allocation Agreement" to the implementer within the selection period to protect your rights.',
      INTRO_OK: 'Got it',
      GRID_NOTICE: 'This chart shows only the paper registrations of the "Updated Allocation Location Application" and the "Combined Allocation Agreement" already submitted. Your simulation results here are not counted and are for reference only.',
      GRID_NEXT: 'Next',
      LEGEND_TITLE: 'Legend',
      LEGEND_ENTER: 'Enter Selection',
      NONPRIORITY_TITLE: 'Non-priority Zone Reminder',
      NONPRIORITY_CONFIRM: 'Confirm',
      NONPRIORITY_RESELECT: 'Reselect',
      SAVE_TITLE: 'Confirm Save',
      SAVE_BODY: 'This housing and parking selection is for reference only and is not counted in the official selection statistics. Please submit the paper originals of the "Updated Allocation Location Application" and the "Combined Allocation Agreement" to the implementer within the selection period to protect your rights.',
      SAVE_CONFIRM: 'Confirm',
      SAVE_CANCEL: 'Back',
      RESULT_TITLE: 'Your Selection Result',
      RESULT_TIME: 'Generated at: {t}',
      RESULT_OWNER: 'Owner',
      RESULT_HOUSE: 'House',
      RESULT_PARK: 'Parking',
      RESULT_EMPTY: 'No unit selected yet',
    },
    CHAT: {
      TITLE: 'AI Assistant',
      COMING_SOON: 'AI Assistant coming soon',
    },
  },
  LICENSE_WARNING: {
    EXPIRING_SOON: 'Your license will expire on {date}. Please contact our sales team to renew.',
    EXPIRED_GRACE: 'Your license expired on {date}. Please contact our sales team to renew as soon as possible. Service will stop on {stopDate}.',
    SUSPENDED: 'Your license expired on {date}. Please contact our sales team to renew and continue using the service.',
    // 佔位文案：正式文案待需求方提供
    INVALID: 'There is a problem with your license information. Please contact our sales team.',
    PREFIX_SUSPENDED: 'Service stopped',
    PREFIX_INVALID: 'Invalid license',
  },
}
